import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import AddFavourite from "../../utility/js/addFav.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import Utility from "../../../shared/utility.js";
import PrinterDetails from "../../common/printer-details";
import addressComp from "../address-comp.vue";
import salesService from "./sales-order-service.js";
import moment from "moment";
import salesOrderEditService from "./sales-order-edit-service.js";
import { bus } from "../../../main.js";
import { Object } from "core-js";
import BackToTop from "../../common/back-to-top.vue";
import DisplayCommentsComp from "../comments-display-comp.vue";
import AddCommentsComp from "../add-comments-comp.vue";
import commonApiService from "../../common/js/common-api-service";
export default {
  data() {
    return {
      route: "",
      activeSoDetailsTab: "line-items",
      currentScrollY: "0",
      expandedLineItems: [],
      lineItemKeywordSearch: "",
      disableHoldBtn: false,
      showReturnAddDDL: false,
      notRequired: false,
      fname: EncryptUtility.localStorageDecrypt("fname"),
      lname: EncryptUtility.localStorageDecrypt("lname"),
      disablePartShip: false,
      showLinkDialog: false,
      expectedDelete: false,
      enableEdit: true,
      showCommentList: true,
      expectedEdit: false,
      disableSignature: false,
      disableSatDel: false,
      show3rdPartyOutbound: false,
      show3rdPartyLocationOutbound: false,
      show3rdPartyInbound: false,
      show3rdPartyLocationInbound: false,
      disable3rdPartyOutbound: true,
      disable3rdPartyInbound: true,
      countryList: [],
      showNewHireDate: true,
      cancelMsg: false,
      disableBuildQty: true,
      convertMsg: false,
      build_id: 0,
      partShipSearchKey: "",
      com_sequence_number: "",
      showAddComments: false,
      commentDialogHeader: "",
      commentId: "",
      editableComment: "",
      hold: false,
      showHold: false,
      selectedReturn: false,
      selectedShip: false,
      showStockStatus: false,
      showHoldBtn: false,
      expectedUpdate: false,
      showOrderedDate: true,
      showShipByDate: true,
      orderDate: "",
      newHireDate: "",
      shipByDate: "",
      displayData: "",
      receivedDataList: [],
      commentList: [],
      tempCommentList: [],
      stockMessage: "",
      fix_price: 0,
      last_price: 0,
      avg_cost: 0,
      showPriceInfo: false,
      minDate: moment(String(new Date())).format("YYYY-MM-DD"),
      contactDate: false,
      contactTime: false,
      followupDate: false,
      conDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      conTime: moment().format("HH:mm"),
      followDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      callLogDeleteDialog: false,
      callLogsData: [],
      callLogSubmitBtnName: "Submit",
      selectedCallLogId: 0,
      soCallLogsDialog: false,
      headerCallLogs: [
        {
          text: "Contact Date",
          align: "start",
          value: "ContactDateTime",
          class: "primary customwhite--text",
        },
        {
          text: "Recipient Name",
          value: "RecipientName",
          class: "primary customwhite--text",
        },
        {
          text: "Method",
          value: "Method",
          class: "primary customwhite--text",
        },
        {
          text: "Outcome",
          value: "Outcome",
          class: "primary customwhite--text",
        },
        {
          text: "Follow-up Date",
          value: "FollowupDate",
          class: "primary customwhite--text",
        },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
        },
      ],
      methodList: [
        {
          text: "",
          value: "",
        },
        {
          text: "Call",
          value: "Call",
        },
        {
          text: "Email",
          value: "Email",
        },
        {
          text: "Incident",
          value: "Incident",
        },
      ],
      outcomeList: [
        {
          text: "",
          value: "",
        },
        {
          text: "Direct",
          value: "Direct",
        },
        {
          text: "Voicemail",
          value: "Voicemail",
        },
        {
          text: "No Answer",
          value: "No Answer",
        },
        {
          text: "Trouble Ticket",
          value: "Trouble Ticket",
        },
      ],
      deleteReasonRule: [
        (v) => !!v || "Field is required",
        (v) =>
          /^(?=.*\S).+$/.test(v) || "Please enter at least one text or number",
        (v) =>
          (v || "").length <= 500 ||
          "Max Length must be 500 characters or less",
      ],
      rmaValidataion: [
        (v) => !!v || "Field is required",
        (v) =>
          /^(?:[ A-Za-z0-9\s\S]){3,25}$/.test(v) ||
          "Please enter at least one text or number, RMA should be greater than 3 characters and less than 25 characters",
      ],
        max20Rule: [
        (v) =>
          (v || "").length <= 20 || "Max Length must be 20 characters or less",
      ],
       max25Rule: [
        (v) => !v ||v?.length <= 25 || "Must be 25 characters or less",
      ],
      max30Rule: [
        (v) => !v || v?.length <= 30 || "Must be 30 characters or less",
      ],
      max50Rule: [
        (v) => v?.length <= 50 || "Must be 50 characters or less",
      ],
      max60Rule: [
        (v) => v?.length <= 60 || "Must be 60 characters or less",
      ],
      emailRule: [
        (v) =>
          !v ||
          /^(?!.*\.\.)(?!.*\s)[A-Za-z0-9]+([._%+-]?[A-Za-z0-9]+)*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,})+$/.test(v) ||
          "Enter valid Email",
      ],
      qtyRule: [
        (v) => !!v || "Field is required",
        (v) => parseInt(v) > 0 || "Field should be greater than 0",
        (v) =>
          parseInt(v) < 2147483647 || "Field should be less than 2,147,483,647",
      ],
      greaterThanRule: [],
      required: [(v) => !!v || "Field is required"],
      line_required: [(v) => parseInt(v) >= 0 || "Field is required"],
      fobValidation: [
        (v) =>
          /^[ A-Za-z0-9_@!%$^*()={}|;:<>,?/./#&+-]*$/.test(v) ||
          "Characters are not allowed",
        (v) =>
          (v || "").length <= 20 || "Max Length must be 20 characters or less",
      ],
      shippingReq: false,
      addressRetRule: [
        (v) => !!v || "Value is not selected",
        this.selectedReturn || "Value is not selected",
      ],
      addressShipRule: [
        (v) => !!v || "Value is not selected",
        this.selectedShip || "Value is not selected",
      ],
      returnReq: false,
      priceValid: [
        (v) => parseInt(v) >= 0 || "Field is required",
        (v) =>
          /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/.test(
            v
          ) || "Upto 2 decimal places are allowed",
      ],
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      mainPage: "",
      favouriteList: [],
      shippedDataList: [],
      showDialogDetailsBox: false,
      showOutboundLog: false,
      greaterThanValidRet: false,
      greaterValRet: "",
      greaterThanRuleRet: [],
      pageUrl: "",
      subPage: "",
      selectedLink: "",
      showAdd: false,
      releaseMsg: false,
      holdMsg: false,
      forceMsg: false,
      subPageUrl: "",
      showbuildDelete: false,
      showbuildEdit: false,
      backSlash: true,
      backSlashParent: true,
      refresh: true,
      pickedDataList: [],
      deleteReasonDialog: false,
      cancelReason: "",
      isAddLine: false,
      orderTypeList: [],
      custSearchKey: "",
      build_Added: false,
      customerList: [],
      shipList: [],
      returnCount: 0,
      shipCount: 0,
      returnList: [],
      disablePartRecieve: false,
      showActionsList: [],
      bookmark: false,
      showLineDelete: false,
      showLineFlagDelete: false,
      showCustomerDialog: false,
      showPartShipDetails: false,
      buildPartNumList: false,
      disableBuildSave: true,
      showPartRetDetails: false,
      showEditShipToDialog: false,
      showShipToDialog: false,
      showReturnToDialog: false,
      showEditReturnToDialog: false,
      deleteBuildDialog: false,
      showEditBuild: false,
      greaterThanValid: false,
      greaterVal: 0,
      shipPartKey: "",
      final_submit: false,
      showForceDialog: false,
      showForceBtn: true,
      editPartQty: "",
      holdReasonDialog: false,
      holdReason: "",
      shipmentHoldConfirmDialog: false,
      shipmentHoldReasonDialog: false,
      shipmentHoldReason: "",
      editPartDesc: "",
      editSerialNum: "",
      editAssetTag: "",
      editProblemDesc: "",
      editWarrentyStatus: "",
      editTrack: "",
      editReturn_carrier: "",
      shipSearchKey: "",
      returnSearchKey: "",
      outboundList: [],
      outboundData: [],
      newHire: false,
      tempOrderLineBackup: {},
      flexHeader: [
        {
          text: "Flex Attribute",
          align: "start",
          value: "flex_code",
          class: "primary customwhite--text",
        },
        {
          text: "Flex Value",
          value: "flex_data",
          class: "primary customwhite--text",
        },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
          sortable: false,
        },
      ],
      headersLineItems: [
        {
          text: "Line#",
          align: "start",
          value: "sequence_number",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "48px",
        },
        {
          text: "Line Type",
          align: "center",
          value: "order_line_text",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "78px",
        },
        {
          text: "",
          align: "center",
          value: "ouboundPresent",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "28px",
        },
        {
          text: "Part Number To Ship",
          align: "start",
          value: "sh_part_number",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "18%",
        },
        {
          text: "Return Part Number",
          align: "start",
          value: "return_part_number",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "15%",
        },
        {
          text: "Warehouses",
          align: "start",
          value: "warehouse_summary",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "13%",
        },
        {
          text: "Ordered",
          align: "center",
          value: "quantity",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "52px",
        },
        {
          text: "Available",
          align: "center",
          value: "Quantity",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "58px",
        },
        { text: "Rcvd", align: "center", value: "Rcvd", class: "primary customwhite--text", cellClass: "line-item-center-cell", width: "46px" },
        { text: "Picked", align: "center", value: "Picked", class: "primary customwhite--text", cellClass: "line-item-center-cell", width: "50px" },
        {
          text: "Shipped",
          align: "center",
          value: "Shipped",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "52px",
        },
        {
          text: "Open Shipments",
          align: "center",
          value: "Open_Shipments",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "56px",
        },
        {
          text: "Open Returns",
          align: "center",
          value: "Open_Receipts",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "52px",
        },
        {
          text: "Flags",
          align: "center",
          value: "line_flags",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "86px",
        },
        {
          text: "Actions",
          align: "center",
          value: "actions",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "48px",
        },
      ],
      headersWarrenty: [
        {
          text: "Serial No",
          align: "start",
          value: "serial_number",
          class: "primary customwhite--text",
        },
        {
          text: "Asset Tag",
          value: "asset_tag",
          class: "primary customwhite--text",
        },
        {
          text: "Problem Description",
          value: "problem_description",
          class: "primary customwhite--text",
        },
        {
          text: "Tracking",
          value: "return_tracking_number",
          class: "primary customwhite--text",
        },
        {
          text: "Return Carrier",
          value: "return_carrier",
          class: "primary customwhite--text",
        },
        {
          text: "Warranty",
          value: "warranty_status",
          class: "primary customwhite--text",
        },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
          sortable: false,
        },
      ],
      headersBuild: [
        {
          text: "Part Number",
          align: "start",
          value: "bo_part_number",
          class: "primary customwhite--text",
        },
        {
          text: "Part Description",
          value: "bo_part_description",
          class: "primary customwhite--text",
        },
        { text: "Qty", value: "bo_qty", class: "primary customwhite--text" },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
          sortable: false,
        },
      ],
      headersPicked: [
        {
          text: "SO Line#",
          align: "start",
          value: "SO Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Part No",
          value: "Part No",
          class: "primary customwhite--text",
        },
        { text: "BCN", value: "BCN", class: "primary customwhite--text" },
        {
          text: "Serial No#",
          value: "Serial#",
          class: "primary customwhite--text",
        },
        { text: "ESN", value: "ESN", class: "primary customwhite--text" },
        { text: "Picked", value: "Picked", class: "primary customwhite--text" },
        { text: "Tech", value: "By", class: "primary customwhite--text" },
        {
          text: "From Bin(LPN)",
          value: "From Bin (LPN)",
          class: "primary customwhite--text",
        },
        { text: "To LPN", value: "To LPN", class: "primary customwhite--text" },
        { text: "Qty", value: "Qty", class: "primary customwhite--text" },
      ],
      headersReceived: [
        {
          text: "SO Line#",
          align: "start",
          value: "SO Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Receiver#",
          value: "Receiver#",
          class: "primary customwhite--text",
        },
        {
          text: "Part No",
          value: "Part No",
          class: "primary customwhite--text",
        },
        { text: "BCN", value: "BCN", class: "primary customwhite--text" },
        {
          text: "Serial",
          value: "Serial#",
          class: "primary customwhite--text",
        },
        { text: "ESN", value: "ESN", class: "primary customwhite--text" },
        { text: "Date", value: "Date", class: "primary customwhite--text" },
        { text: "Tech", value: "Tech", class: "primary customwhite--text" },
        {
          text: "Packing Slip",
          value: "Packing Slip",
          class: "primary customwhite--text",
        },
        {
          text: "Waybill#",
          value: "Waybill#",
          class: "primary customwhite--text",
        },
        { text: "Qty", value: "Qty", class: "primary customwhite--text" },
        { text: "Credit", value: "Credit", class: "primary customwhite--text" },
        {
          text: "Extra Credit",
          value: "Ext Credit",
          class: "primary customwhite--text",
        },
      ],
      headersShipped: [
        {
          text: "SO Line#",
          align: "start",
          value: "SO Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Shipper#",
          value: "Shipper#",
          class: "primary customwhite--text",
        },
        {
          text: "Part No",
          value: "Part No",
          class: "primary customwhite--text",
        },
        { text: "BCN", value: "BCN", class: "primary customwhite--text" },
        {
          text: "Serial",
          value: "Serial#",
          class: "primary customwhite--text",
        },
        { text: "ESN", value: "ESN", class: "primary customwhite--text" },
        { text: "shipped", value: "Date", class: "primary customwhite--text" },
        { text: "Tech", value: "Tech", class: "primary customwhite--text" },
        {
          text: "Packing Slip",
          value: "Packing Slip",
          class: "primary customwhite--text",
        },
        {
          text: "Waybill#",
          value: "Waybill",
          class: "primary customwhite--text",
        },
        {
          text: "Return Waybill#",
          value: "RtnWaybill",
          class: "primary customwhite--text",
        },
        { text: "Qty", value: "Qty", class: "primary customwhite--text" },
        { text: "Credit", value: "Credit", class: "primary customwhite--text" },
        {
          text: "Extra Credit",
          value: "Ext Credit",
          class: "primary customwhite--text",
        },
        {
          text: "Outbound Label",
          value: "Outbound_Label",
          class: "primary customwhite--text",
        },
        {
          text: "Inbound Label",
          value: "Inbound_Label",
          class: "primary customwhite--text",
        },
      ],

      inboundDetailsHeaders: [
        {
          text: "Process Type",
          align: "start",
          value: "process_type",
          class: "primary customwhite--text",
        },
        {
          text: "Request",
          value: "request",
          class: "primary customwhite--text",
        },
        // { text: "XML", value: "request_xml", class: "primary customwhite--text" },
        {
          text: "Record Date",
          value: "created_date",
          class: "primary customwhite--text",
        },
      ],
      outboundDetailsHeaders: [
        {
          text: "Process Type",
          align: "start",
          value: "process_type",
          class: "primary customwhite--text",
        },
        {
          text: "Request",
          value: "request",
          class: "primary customwhite--text",
        },
        {
          text: "Record Date",
          value: "created_date",
          class: "primary customwhite--text",
        },
        {
          text: "Response",
          value: "response",
          class: "primary customwhite--text",
        },
        {
          text: "Sent Date",
          value: "retrieved",
          class: "primary customwhite--text",
        },
        {
          text: "Status",
          value: "msg_status",
          class: "primary customwhite--text",
        },
      ],

      // inboundDetailsHeaders: [
      //   { text: "Process Type", align: "start", value: "process_type", class: "primary customwhite--text" },
      //   { text: " Json", value: "request_json", class: "primary customwhite--text" },
      //   { text: " XML", value: "request_xml", class: "primary customwhite--text" },
      //   { text: "Created Date", value: "created_date", class: "primary customwhite--text" },

      // ],

      //   outboundDetailsHeaders:
      //     [
      //       { text: "Sent Date", align: "start", value: "retrieved", class: "primary customwhite--text" },
      //       { text: "Response", value: "response", class: "primary customwhite--text" },
      //       { text: "Status", value: "msg_status", class: "primary customwhite--text" },

      //     ],
      ouboundLogHeader: [
        {
          text: "Client Response Json",
          align: "start",
          value: "client_response_json",
          class: "primary customwhite--text",
        },
        {
          text: "Retrieved",
          value: "retrieved",
          class: "primary customwhite--text",
        },
      ],
      inboundList: [],
      inboundDataList: [],
      outboundDataList: [],
      panel: [0, 1, 2, 3, 4],
      salesOrderId: "",
      edit_line_num: "",
      expected_serial_number_list: [],
      lineItemPanel: [0, 1],
      showFlexDialog: false,
      showConevertDropDown: false,
      flex_field_Att: "",
      flex_value: "",
      showPartsItem: false,
      showBookMark: false,
      lineTypeList: [],
      disableLine: false,
      disableQty: false,
      showPartShip: false,
      showPartRet: false,
      showFlex: false,
      disableRetQty: false,
      partNumbertoShip: "",
      partResultList: [],
      showPartDetails: false,
      showBuildIcon: false,
      showBuildExpand: false,
      selectedShipFromWare: "",
      shipWareList: [],
      convertedList: [],
      partBuildPartNum: "",
      buildPartResultList: [],
      buildToQty: "",
      returnWareList: [],
      partReturnSearchKey: "",
      returnResultList: [],
      returnPartNum: "",
      returnPartDesc: "",
      showexpIcon: false,
      showExpectedSr: false,
      soDelete: false,
      serial_num: "",
      asset_tag: "",
      tracking_num: "",
      warr_status: "N",
      returnCarrier: "",
      temp_waybill_id: "",
      buildOrderList: [],
      salesOrderDetails: "",
      refreshDialog: false,
      isEditing: true,
      flexDisplayList: [],
      revertToBackOrderDialog: false,
      forceAllocateOrderDialog: false,
      clearShippingAuditDialog: false,
      linePriceWarningDialog: false,
      isSubmitAction: false,
      // SO JSON
      salesOrderJson: {
        so_id: "",
        request_number: "",
        order_number: "",
        proj_id: "",
        bu_id: "",
        inbound_status: "",
        rma: "",
        ordered_date: "",
        outbound_status: "",
        customer_number: "",
        requested_ship_date: "",
        order_type: "",
        order_type_id: "",
        customer_po: "",
        customer_order_number: "",
        fob: "",
        pay_term_id: "",
        ritm: "",
        shipment_terms: "",
        employee_name: "",
        employee_email: "",
        employee_id: "",
        site_id: "",
        cost_center: "",
        new_hire: false,
        new_hire_date: "",
        is_shipping_hold: false,
        CustomerInfo: [
          {
            title: "",
            last: "",
            cust_id: "",
            custno: "",
            company: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            phone1: "",
            phone2: "",
            cell: "",
            fax: "",
            email: "",
          },
        ],
        shipment_address: [
          {
            sh_title: "",
            sh_first: "",
            sh_last: "",
            sh_custno: "",
            sh_company: "",
            sh_address1: "",
            sh_address2: "",
            sh_city: "",
            sh_state: "",
            sh_zip: "",
            sh_country: "",
            sh_phone1: "",
            sh_phone2: "",
            sh_cell: "",
            sh_fax: "",
            sh_email: "",
            sh_additional_email: "",
            sh_cust_id: "",
          },
        ],
        return_address: [
          {
            rt_title: "",
            rt_first: "",
            rt_last: "",
            rt_comp_id: "",
            rt_custno: "",
            rt_company: "",
            rt_address1: "",
            rt_address2: "",
            rt_city: "",
            rt_state: "",
            rt_zip: "",
            rt_country: "",
            rt_phone1: "",
            rt_phone2: "",
            rt_cell: "",
            rt_fax: "",
            rt_email: "",
          },
        ],
        shipping_priority: "",
        return_shipping_priority: "",
        signature_required: false,
        saturday_delivery: false,
        account_3rd_party: "",
        zip_3rd_party: "",
        countrycode_3rd_party: "",
        account_3rd_party_rtn: "",
        zip_3rd_party_rtn: "",
        countrycode_3rd_party_rtn: "",
        order_notes: "",
        problem_description: "",
        so_notes: "",
        flex_field: [],
        order_list: [],
        order_line: [],
        timeline_info: [],
        showTATInfo: false,
      },
      //TEMPJSON
      temp_order_line: {
        sequence_number: "",
        order_line_type_text: "",
        order_line_type: "",
        line_number: "",
        sh_part_id: "",
        sh_part_number: "",
        sh_part_description: "",
        sh_from_warehouse_id: "",
        sh_from_warehouse: "",
        sh_from_inventory_bucket: "",
        sh_quantity: "",
        sh_price: 0.0,
        build_orders: {
          build_order_notes: "",
          build_order: [],
        },
        return_part_id: "",
        return_part_number: "",
        return_part_description: "",
        return_to_warehouse_id: "",
        return_to_warehouse: "",
        return_to_inventory_bucket: "",
        return_quantity: "",
        return_price: "",
        return_rma: "",
        expected_serial_number: [],
        line_comment: "",
        flex_field: [],
        // Add by Dev team for showing text
        order_line_text: "",
        showPartRet: "",
        showPartShip: "",
        showBuild: "",
        showSerial: "",
        quantity: 0,
        Allocated: 0,
        Picked: 0,
        shipped: 0,
      },
      soHistory: false,
      salesOrderHistoryRecords: [],
      salesOrderHistoryItems: [],
      salesOrderHistoryDialog: false,
      salesOrderHistoryActionFilter: "All Actions",
      salesOrderHistoryEntityFilter: "All Entities",
      salesOrderHistoryUserFilter: "All Users",
      salesOrderHistorySearch: "",
      headersSalesOrderHistory: [
        {
          text: "Action",
          align: "start",
          value: "Action",
          class: "primary customwhite--text",
        },
        { text: "Changed", value: "Changed", class: "primary customwhite--text" },
        { text: "Changed By", value: "ChangedBy", class: "primary customwhite--text" },
        { text: "Entity", value: "Entity", class: "primary customwhite--text" },
        { text: "Field", value: "Field", class: "primary customwhite--text" },
        { text: "Old Value", value: "OldValue", class: "primary customwhite--text" },
        { text: "New Value", value: "NewValue", class: "primary customwhite--text" },
      ],
      trackingCurrentStatus: "",
      trackingWaybillHistoryDialog: false,
      trackingWaybillHistoryItems: [],
      trackingExpandedWaybills: [],
      trackingShowAllWaybills: [],
      headersTrackingWaybillHistory: [
        { text: "Waybill", align: "center", value: "WayBill", class: "primary customwhite--text", sortable: false, width: "20%" },
        { text: "Date", align: "center", value: "Date", class: "primary customwhite--text", sortable: false, width: "20%" },
        { text: "Status", align: "center", value: "Status", class: "primary customwhite--text", sortable: false, width: "60%" },
      ],
      labelDialog: false,
      labelDialogName: "",
      labelLink: "",
      labelType: "",
      labelZpl: "",
      labelRaw: "",
      labelHistoryDialog: false,
      labelHistoryDir: "",
      labelHistorySorecpId: 0,
      labelHistoryData: [],
      headersLabelHistory: [
        {
          text: "Waybill",
          align: "start",
          value: "waybill",
          class: "primary customwhite--text",
        },
        {
          text: "Shipped Date",
          value: "cdate",
          class: "primary customwhite--text",
        },
        {
          text: "Tech",
          value: "username",
          class: "primary customwhite--text",
        },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    //to Load Data
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = data?.actionList;
    let actionData = await AddFavourite.getParentPageAction(
      this.userId,
      "sales-order-details"
    ); // URL hard coded
    let pagePermissions = actionData?.actionList;
    pagePermissions?.forEach((element) => {
      this.actionList.push(element);
    });
    let parentActionData = await AddFavourite.getParentPageAction(this.userId, "sales-order"); // URL hard coded
    let parentPagePermissions = parentActionData?.actionList;
    parentPagePermissions?.forEach((element) => {
      this.actionList.push(element);
    });
    this.mainPage = data?.mainPage;
    this.favouriteList = data?.favouriteList;
    this.pageUrl = data?.pageUrl;
    this.subPage = data?.subPage;
    this.showAdd = data?.showAdd;
    this.subPageUrl = data?.subPageUrl;
    this.appPageName = data?.appPageName;
    let LoaderDialog = {
      visible: true,
      title: "Please Wait...",
    };
    this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    // to load the Project Dropdown
    this.salesOrderId = atob(this.$route.params.salesOrderId);
    this.salesOrderDetails = await salesOrderEditService.getSalesOrderDetails(
      "get",
      this.userId,
      this.salesOrderId
    );
    // Assigning the values we get from API to the Form JSON we created
    this.convertTime();
    this.getSOCallLogs();
    this.getTrackingStatus();
    this.showHoldBtn = Boolean(this.salesOrderJson.enable_hold);
    this.returnSearchKey = this.salesOrderJson.return_address[0].rt_company;
    if (this.returnSearchKey) this.selectedReturn = true;
    this.salesOrderJson.order_list?.forEach((v) => {
      v.isEdited = false;
    });
    this.bookmark = Boolean(this.salesOrderJson.is_bookmark);
    //Actions for Hold
    if (this.showHoldBtn) {
      if (this.hold)
        this.showActionsList.push({
          Id: "SO-Release",
          Icon: "mdi mdi-play-outline",
          FriendlyName: "SO Release",
        });
      else if (!this.isShippingHold)
        this.showActionsList.push({
          Id: "SO-Hold",
          Icon: "mdi mdi-pause-box-outline",
          FriendlyName: "SO Hold",
        });
    }
    if (this.canShowShipmentHold) {
      this.showActionsList.push({
        Id: "SO-ShipmentHold",
        Icon: "mdi-truck-alert-outline",
        FriendlyName: "Shipment Hold",
      });
    }
    if (this.bookmark)
      this.showActionsList.push({
        Id: "SO-BookMark-Remove",
        Icon: "mdi mdi-bookmark-outline",
        FriendlyName: "Remove Bookmark",
      });
    else
      this.showActionsList.push({
        Id: "SO-BookMark",
        Icon: "mdi mdi-bookmark",
        FriendlyName: "Add Bookmark",
      });
    this.salesOrderJson.so_id = this.salesOrderId;
    this.flexDisplayList = JSON.parse(
      JSON.stringify(this.salesOrderJson.flex_field)
    );
    // API CALL for Order Type
    let businessObj = {
      UserId: this.userId,
      bu_key: this.salesOrderJson.bu_id,
      pass: 1,
    };
    let orderTypeData = await salesOrderEditService.postOrderTypeData(
      "post",
      businessObj
    );
    if (orderTypeData?.OrderTypes) {
      this.notRequired = true;
      this.orderTypeList = orderTypeData.OrderTypes?.map((x) => ({
        ord_code: x.ord_code,
        ordCodedesc: x.ordCodedesc,
      }));
    } else {
      this.notRequired = false;
    }
    this.paymentList = orderTypeData?.PaymentTerms;
    // Warehouse List
    // Carrier API
    let carrierObj = {
      UserId: this.userId,
      bu_key: this.salesOrderJson.bu_id,
      custpo: this.salesOrderJson.customer_po,
      order_type: this.salesOrderJson.order_type,
    };
    let carrierData = await salesOrderEditService.postcarrierServiceLvlData(
      carrierObj
    );
    this.outboundList = carrierData?.OutboundSLs;
    this.inboundList = carrierData?.InboundSLs;
    this.inboundDataList?.forEach((element) => {
      element.created_date = Utility.displayDateFormat(element.created_date);
    });
    if(this.salesOrderDetails?.Result[0]?.outbound_default_key !== "" || this.salesOrderDetails?.Result[0]?.outbound_default_key !== null || this.salesOrderDetails?.Result[0]?.outbound_default_key !== undefined || this.salesOrderDetails?.Result[0]?.outbound_default_key !== 0){
      this.salesOrderJson.shipping_priority = this.salesOrderDetails?.Result[0]?.outbound_default_key;
    }  
    if (this.salesOrderJson.shipping_priority !== "" && this.salesOrderJson.shipping_priority !== null && this.salesOrderJson.shipping_priority !== undefined && this.salesOrderJson.shipping_priority !== 0)
    {
     let CarrierFlags_carrier = this.outboundList?.filter(
        (x) => x.sl_id == this.salesOrderJson.shipping_priority
      );
      this.disableSatDel = CarrierFlags_carrier[0].sat_delivery;
      const showLocationOutbound = Boolean(CarrierFlags_carrier[0]?.show_3rdparty_location);
      if (showLocationOutbound) await this.loadCountryList();
      this.show3rdPartyOutbound = Boolean(CarrierFlags_carrier[0]?.show_3rdparty);
      this.show3rdPartyLocationOutbound = showLocationOutbound;
      if (this.show3rdPartyOutbound && !this.salesOrderJson.account_3rd_party) {
        this.salesOrderJson.account_3rd_party = CarrierFlags_carrier[0]?.account_3rd_party || "";
      }
      if (this.show3rdPartyLocationOutbound) {
        if (!this.salesOrderJson.zip_3rd_party) this.salesOrderJson.zip_3rd_party = CarrierFlags_carrier[0]?.zip_3rdparty || "";
        if (!this.salesOrderJson.countrycode_3rd_party) this.salesOrderJson.countrycode_3rd_party = CarrierFlags_carrier[0]?.country_3rdparty || "";
      }
    }
    if(this.salesOrderDetails?.Result[0]?.inbound_default_key !== "" || this.salesOrderDetails?.Result[0]?.inbound_default_key !== null || this.salesOrderDetails?.Result[0]?.inbound_default_key !== undefined || this.salesOrderDetails?.Result[0]?.inbound_default_key !== 0){
      this.salesOrderJson.return_shipping_priority = this.salesOrderDetails?.Result[0]?.inbound_default_key;
    }
    if (this.salesOrderJson.return_shipping_priority !== "" && this.salesOrderJson.return_shipping_priority !== null && this.salesOrderJson.return_shipping_priority !== undefined && this.salesOrderJson.return_shipping_priority !== 0) {
      let CarrierFlags_inbound = this.inboundList?.filter(
        (x) => x.sl_id == this.salesOrderJson.return_shipping_priority
      );
      if (CarrierFlags_inbound?.length > 0) {
        const showLocationInbound = Boolean(CarrierFlags_inbound[0]?.show_3rdparty_location);
        if (showLocationInbound) await this.loadCountryList();
        this.show3rdPartyInbound = Boolean(CarrierFlags_inbound[0]?.show_3rdparty);
        this.show3rdPartyLocationInbound = showLocationInbound;
        if (this.show3rdPartyInbound && !this.salesOrderJson.account_3rd_party_rtn) {
          this.salesOrderJson.account_3rd_party_rtn = CarrierFlags_inbound[0]?.account_3rd_party || "";
        }
        if (this.show3rdPartyLocationInbound) {
          if (!this.salesOrderJson.zip_3rd_party_rtn) this.salesOrderJson.zip_3rd_party_rtn = CarrierFlags_inbound[0]?.zip_3rdparty || "";
          if (!this.salesOrderJson.countrycode_3rd_party_rtn) this.salesOrderJson.countrycode_3rd_party_rtn = CarrierFlags_inbound[0]?.country_3rdparty || "";
        }
      }
    }
    this.shipSearchKey = this.salesOrderJson.shipment_address[0]?.sh_company;
    if (this.shipSearchKey) this.selectedShip = true;
    //this.custSearchKey = this.salesOrderJson?.CustomerInfo[0]?.company;
    LoaderDialog.visible = false;
    this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    this.setActionFunction();
    this.restoreDetailsEditPosition();
  },
  // For Reload Functionality
  beforeMount() {
    this.captureScrollPosition();
    window.addEventListener("scroll", this.captureScrollPosition, { passive: true });
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("scroll", this.captureScrollPosition);
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },
  // To Check if router is changed
  beforeRouteLeave(to, from, next) {
    let soBackup = JSON.parse(JSON.stringify(this.salesOrderDetails.Result[0]));
    soBackup.order_list?.forEach((v) => {
      v.isEdited = false;
    });
    soBackup.so_id = String(soBackup.so_id);
    if (JSON.stringify(soBackup) != JSON.stringify(this.salesOrderJson)) {
      if (!this.final_submit) this.isEditing = true;
      else this.isEditing = false;
    } else {
      this.isEditing = false;
    }
    if (this.isEditing) {
      if (window.confirm("Leave without saving?")) {
        next();
      } else {
        return false;
      }
    }
    next();
  },
  computed: {
    salesOrderDetailsReturnUrl() {
      const query = new URLSearchParams({
        tab: this.activeSoDetailsTab,
        scrollY: this.currentScrollY,
      }).toString();
      return `/sales-order-details/${btoa(this.salesOrderId.toString())}?${query}`;
    },
    shipToAddress() {
      return this.salesOrderJson?.shipment_address?.[0] || {};
    },
    shipToCompany() {
      return String(this.shipToAddress.sh_company || "").trim();
    },
    shipToContactName() {
      return [
        this.shipToAddress.sh_first,
        this.shipToAddress.sh_last,
      ].map((value) => String(value || "").trim()).filter(Boolean).join(" ");
    },
    shipToStreetLines() {
      return [
        this.shipToAddress.sh_address1,
        this.shipToAddress.sh_address2,
      ].map((value) => String(value || "").trim()).filter(Boolean);
    },
    shipToCityStateZipLine() {
      const city = String(this.shipToAddress.sh_city || "").trim();
      const stateZip = [
        this.shipToAddress.sh_state,
        this.shipToAddress.sh_zip,
      ].map((value) => String(value || "").trim()).filter(Boolean).join(" ");
      return [city, stateZip].filter(Boolean).join(", ");
    },
    shipToCountry() {
      return String(this.shipToAddress.sh_country || "").trim();
    },
    shipToPhoneLine() {
      return [
        this.shipToAddress.sh_phone1,
        this.shipToAddress.sh_phone2,
      ].map((value) => String(value || "").trim()).filter(Boolean).join(" ");
    },
    shipToContactRows() {
      return [
        { key: "phone", icon: "mdi-phone", value: this.shipToPhoneLine },
        { key: "cell", icon: "mdi-cellphone", value: this.shipToAddress.sh_cell },
        { key: "fax", icon: "mdi-fax", value: this.shipToAddress.sh_fax },
        { key: "email", icon: "mdi-email-outline", value: this.shipToAddress.sh_email },
        {
          key: "additional-email",
          icon: "mdi-email-multiple-outline",
          value: String(this.shipToAddress.sh_additional_email || "").replace(/;/g, " "),
        },
      ].map((row) => ({ ...row, value: String(row.value || "").trim() })).filter((row) => Boolean(row.value));
    },
    hasShipToAddress() {
      return Boolean(
        this.shipToContactName ||
        this.shipToCompany ||
        this.shipToStreetLines.length ||
        this.shipToCityStateZipLine ||
        this.shipToCountry ||
        this.shipToContactRows.length
      );
    },
    soDetailsSectionTabs() {
      return [
        { text: "Line Item", value: "line-items", icon: "mdi-invoice-list-outline" },
        { text: "Address", value: "addresses", icon: "mdi-map-marker-outline" },
        { text: "Carrier", value: "carrier", icon: "mdi-truck" },
        { text: "Note", value: "notes", icon: "mdi-note-outline" },
        { text: "Call Log", value: "call-logs", icon: "mdi-phone-log" },
        { text: "Flex Data", value: "flex-data", icon: "mdi-database-plus-outline" },
        {
          text: "Inbound Log",
          value: "inbound-log",
          icon: "mdi-file-download-outline",
          visible: this.actionSetter("ViewInboundDetails") && this.inboundDataList?.length > 0,
        },
        {
          text: "Outbound Log",
          value: "outbound-log",
          icon: "mdi-file-upload-outline",
          visible: this.actionSetter("ViewOutboundDetails") && this.outboundDataList?.length > 0,
        },
        { text: "Order History", value: "order-history", icon: "mdi-history" },
      ].filter((section) => section.visible !== false);
    },
    isShippingHold() {
      const value = this.salesOrderJson?.is_shipping_hold;
      return value === true || value === 1 || String(value).toLowerCase() === "true";
    },
    canShowShipmentHold() {
      const orderStatus = String(
        this.salesOrderJson?.order_status_code ||
        this.salesOrderJson?.current_status ||
        this.salesOrderJson?.order_status ||
        this.salesOrderJson?.status ||
        this.salesOrderJson?.outbound_status ||
        ""
      ).trim().toUpperCase();
      return this.actionSetter("ShipmentHold") && !["C", "X"].includes(orderStatus);
    },
    computedDateFormattedMomentjs() {
      return this.salesOrderJson.ordered_date
        ? moment(String(this.salesOrderJson.ordered_date)).format("MM/DD/YYYY")
        : moment(String(new Date())).format("MM/DD/YYYY");
    },
    summaryOrderDateFormatted() {
      return this.salesOrderJson.ordered_date
        ? moment(String(this.salesOrderJson.ordered_date)).format("MM/DD/YYYY")
        : "";
    },
    summaryEstimatedShipDateFormatted() {
      const orderStatusCode = String(this.salesOrderJson?.order_status_code || "").trim().toUpperCase();
      if (["C", "X"].includes(orderStatusCode)) return "";

      const timeline = this.timelineInfo();
      const expectedShipByDate = timeline.ExpectedShipByDate || timeline.expected_ship_by_date;
      const date = expectedShipByDate || this.salesOrderJson.requested_ship_date;
      return date ? moment(String(date)).format("MM/DD/YYYY") : "";
    },
    trackingCurrentStatusLinkText() {
      return String(this.trackingCurrentStatus || "").trim().toLowerCase() === "multiline"
        ? "Multiple Tracking Numbers"
        : this.trackingCurrentStatus;
    },
    shipcomputeDateFormattedMomentjs() {
      return this.salesOrderJson.requested_ship_date
        ? moment(String(this.salesOrderJson.requested_ship_date)).format(
            "MM/DD/YYYY"
          )
        : "";
    },
    newHireComputedDateFormattedMomentjs() {
      return this.salesOrderJson.new_hire_date
        ? moment(this.salesOrderJson.new_hire_date).format("MM/DD/YYYY")
        : "";
    },
    computedContactDateFormattedMomentjs() {
      return this.conDate
        ? moment(this.conDate, "YYYY-MM-DD").format("MM/DD/YYYY")
        : "";
    },
    computedContactTimeFormattedMomentjs() {
      return this.conTime
        ? moment(this.conTime, "HH:mm").format("hh:mm A")
        : "";
    },
    computedFollowupDateFormattedMomentjs() {
      return this.followDate ? moment(this.followDate).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY");
    },
    filteredCallLogs() {
      return this.callLogsData.filter((x) => !x.is_Deleted);
    },
    filteredSalesOrderLineItems() {
      const search = this.lineItemKeywordSearch?.trim().toLowerCase();
      const lines = this.salesOrderJson.order_list || [];
      if (!search) return lines;

      return lines.filter((item) => {
        const searchableText = [
          item.sh_part_number,
          item.sh_part_description,
          item.return_part_number,
          item.return_part_description,
          item.sh_from_warehouse,
          item.sh_from_inventory_bucket,
          item.return_to_warehouse,
          item.return_to_inventory_bucket,
        ].join(" ").toLowerCase();
        return searchableText.includes(search);
      });
    },
    showLineItemStatuses() {
      const orderStatusCode = String(this.salesOrderJson?.order_status_code || "").trim().toUpperCase();
      return !["C", "X"].includes(orderStatusCode);
    },
    callLogRowCount() {
      return this.filteredCallLogs.length;
    },
    frameSrc() {
      return this.labelLink;
    },
    shippedHeadersFiltered() {
      return this.actionSetter("ViewShippingLabel")
        ? this.headersShipped
        : this.headersShipped.filter(
            (header) =>
              header.value !== "Outbound_Label" &&
              header.value !== "Inbound_Label"
          );
    },
    salesOrderHistoryActionOptions() {
      return ["All Actions", ...new Set(this.salesOrderHistoryRecords.map((item) => item.Action).filter(Boolean))];
    },
    salesOrderHistoryEntityOptions() {
      return ["All Entities", ...new Set(this.salesOrderHistoryRecords.map((item) => item.Entity).filter(Boolean))];
    },
    salesOrderHistoryUserOptions() {
      return ["All Users", ...new Set(this.salesOrderHistoryRecords.map((item) => item.ChangedBy).filter(Boolean))];
    },
    filteredSalesOrderHistoryRecords() {
      const search = this.salesOrderHistorySearch?.toLowerCase().trim();
      return this.salesOrderHistoryRecords.filter((item) => {
        const actionMatch = this.salesOrderHistoryActionFilter === "All Actions" || item.Action === this.salesOrderHistoryActionFilter;
        const entityMatch = this.salesOrderHistoryEntityFilter === "All Entities" || item.Entity === this.salesOrderHistoryEntityFilter;
        const userMatch = this.salesOrderHistoryUserFilter === "All Users" || item.ChangedBy === this.salesOrderHistoryUserFilter;
        const changeText = item.Changes.reduce((values, change) => {
          values.push(change.Field, change.OldValue, change.NewValue);
          return values;
        }, []);
        const searchText = [
          item.Action,
          item.Entity,
          item.ChangedBy,
          ...changeText,
        ].join(" ").toLowerCase();
        return actionMatch && entityMatch && userMatch && (!search || searchText.includes(search));
      });
    },
    groupedSalesOrderHistoryRecords() {
      return this.filteredSalesOrderHistoryRecords.reduce((groups, item) => {
        const label = item.Changed ? moment(item.Changed).format("MMM DD, YYYY").toUpperCase() : "NO DATE";
        let group = groups.find((entry) => entry.date === label);
        if (!group) {
          group = { date: label, records: [] };
          groups.push(group);
        }
        group.records.push(item);
        return groups;
      }, []);
    },
    trackingWaybillGroups() {
      return this.trackingWaybillHistoryItems.reduce((groups, item) => {
        const waybill = item.WayBill || item.Waybill || item.waybill || "Unknown";
        let group = groups.find((entry) => entry.waybill === waybill);
        if (!group) {
          group = {
            key: `${waybill}-${groups.length}`,
            waybill,
            events: [],
            currentStatus: item.Status || "",
            currentDate: item.Date || "",
          };
          groups.push(group);
        }
        group.events.push(item);
        if (!group.currentStatus && item.Status) group.currentStatus = item.Status;
        if (!group.currentDate && item.Date) group.currentDate = item.Date;
        return groups;
      }, []);
    },
  },
  mounted() {},
  watch: {
    activeSoDetailsTab(value) {
      if (value === "order-history") {
        this.loadSalesOrderHistory();
      }
    },
  },
  methods: {
    captureScrollPosition() {
      this.currentScrollY = String(window.pageYOffset || document.documentElement.scrollTop || 0);
    },
    salesOrderDetailsReturnQuery() {
      this.captureScrollPosition();
      return {
        tab: this.activeSoDetailsTab,
        scrollY: this.currentScrollY,
      };
    },
    isEmptyDefaultDate(date) {
      return !date || String(date).trim() === "1900-01-01T00:00:00";
    },
    formatTimelineDate(date) {
      return date ? moment(date).format("MM/DD/YY") : "";
    },
    lineItemExpandKey(item) {
      const index = this.salesOrderJson?.order_list?.indexOf(item) ?? "";
      return `${item?.line_number || item?.sequence_number || index}`;
    },
    isLineItemExpanded(item) {
      return this.expandedLineItems.includes(this.lineItemExpandKey(item));
    },
    toggleLineItemExpanded(item) {
      const key = this.lineItemExpandKey(item);
      if (this.expandedLineItems.includes(key)) {
        this.expandedLineItems = this.expandedLineItems.filter((lineKey) => lineKey !== key);
      } else {
        this.expandedLineItems = [...this.expandedLineItems, key];
      }
    },
    openCallLogTab() {
      this.activeSoDetailsTab = "call-logs";
      this.$nextTick(() => {
        const tabCard = this.$el?.querySelector(".so-section-tabs-card");
        if (tabCard) {
          tabCard.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    isTrackingWaybillExpanded(group) {
      return this.trackingExpandedWaybills.includes(group.key);
    },
    toggleTrackingWaybillExpanded(group) {
      if (this.isTrackingWaybillExpanded(group)) {
        this.trackingExpandedWaybills = this.trackingExpandedWaybills.filter((key) => key !== group.key);
      } else {
        this.trackingExpandedWaybills = [...this.trackingExpandedWaybills, group.key];
      }
    },
    allTrackingWaybillsExpanded() {
      return this.trackingWaybillGroups.length > 0 && this.trackingExpandedWaybills.length === this.trackingWaybillGroups.length;
    },
    toggleAllTrackingWaybills() {
      this.trackingExpandedWaybills = this.allTrackingWaybillsExpanded()
        ? []
        : this.trackingWaybillGroups.map((group) => group.key);
    },
    isTrackingWaybillShowingAll(group) {
      return this.trackingShowAllWaybills.includes(group.key);
    },
    toggleTrackingWaybillShowAll(group) {
      if (this.isTrackingWaybillShowingAll(group)) {
        this.trackingShowAllWaybills = this.trackingShowAllWaybills.filter((key) => key !== group.key);
      } else {
        this.trackingShowAllWaybills = [...this.trackingShowAllWaybills, group.key];
      }
    },
    visibleTrackingEvents(group) {
      return this.isTrackingWaybillShowingAll(group) ? group.events : group.events.slice(0, 5);
    },
    trackingStatusClass(status) {
      const normalized = String(status || "").toLowerCase();
      if (normalized.includes("deliver")) return "tracking-waybill-status--delivered";
      if (normalized.includes("exception") || normalized.includes("fail") || normalized.includes("cancel")) return "tracking-waybill-status--alert";
      return "tracking-waybill-status--active";
    },
    statusBadgeStyle(backgroundColor, borderColor, textColor) {
      const style = {};
      const bgColor = String(backgroundColor || "").trim();
      const brColor = String(borderColor || "").trim();
      const txtColor = String(textColor || "").trim();
      if (bgColor) style.backgroundColor = bgColor;
      if (brColor) style.borderColor = brColor;
      if (txtColor) style.color = txtColor;
      return style;
    },
    statusDotStyle(statusColor) {
      const backgroundColor = String(statusColor || "").trim();
      return backgroundColor ? { backgroundColor } : {};
    },
    statusTextStyle(textColor, fallbackColor) {
      const rawColor = String(textColor || "").trim();
      const normalized = rawColor.toLowerCase();
      const color = rawColor && !["#fff", "#ffffff", "white", "transparent"].includes(normalized)
        ? rawColor
        : String(fallbackColor || "").trim();
      return color ? { color } : {};
    },
    mapSalesOrderResultFields() {
      const result = this.salesOrderDetails?.Result?.[0] || {};
      this.salesOrderJson.employee_email = result.employee_email || "";
      this.$set(this.salesOrderJson, "site_id", result.site_id || "");
      this.$set(this.salesOrderJson, "cost_center", result.cost_center || "");
    },
    buildSalesOrderSaveJson() {
      const saveJson = {};
      Object.keys(this.salesOrderJson).forEach((key) => {
        if (key === "site_id" || key === "cost_center") return;
        saveJson[key] = key === "fob" ? "" : this.salesOrderJson[key];
        if (key === "employee_name") {
          saveJson.employee_email = this.salesOrderJson.employee_email || "";
          saveJson.site_id = this.salesOrderJson.site_id || "";
          saveJson.cost_center = this.salesOrderJson.cost_center || "";
        } else if (key === "employee_email" && !Object.prototype.hasOwnProperty.call(saveJson, "site_id")) {
          saveJson.site_id = this.salesOrderJson.site_id || "";
          saveJson.cost_center = this.salesOrderJson.cost_center || "";
        }
      });
      if (!Object.prototype.hasOwnProperty.call(saveJson, "employee_email")) {
        saveJson.employee_email = this.salesOrderJson.employee_email || "";
        saveJson.site_id = this.salesOrderJson.site_id || "";
        saveJson.cost_center = this.salesOrderJson.cost_center || "";
      }
      return saveJson;
    },
    validateOptionalForm(refName) {
      const form = this.$refs[refName];
      return !form || form.validate();
    },
    scrollToInvalidFormField(refName) {
      const invalidField = this.$refs[refName]?.$children?.find((e) => !e.valid);
      if (invalidField) {
        invalidField.$el.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    },
    restoreDetailsEditPosition() {
      const tab = this.$route.query?.tab;
      if (tab && this.soDetailsSectionTabs.some((section) => section.value === tab)) {
        this.activeSoDetailsTab = tab;
      }

      const scrollY = Number.parseInt(this.$route.query?.scrollY, 10);
      if (Number.isNaN(scrollY)) return;

      this.$nextTick(() => {
        window.setTimeout(() => {
          window.scrollTo({
            top: scrollY,
            left: 0,
            behavior: "auto",
          });
        }, 0);
      });
    },
    timelineInfo() {
      const timelineInfo = this.salesOrderJson?.timeline_info || this.salesOrderJson?.timelineinfo || [];
      return Array.isArray(timelineInfo) ? (timelineInfo[0] || {}) : (timelineInfo || {});
    },
    showTimelinePrompts() {
      const timelineInfo = this.salesOrderJson?.timeline_info || [];
      const hasTimelineInfo = Array.isArray(timelineInfo)
        ? timelineInfo.length > 0 && Object.keys(timelineInfo[0] || {}).length > 0
        : Object.keys(timelineInfo || {}).length > 0;
      if (!hasTimelineInfo) return false;

      const timeline = this.timelineInfo();
      const timelineEnabled =
        timeline.TimelineEnabled ??
        timeline.timeline_enabled ??
        this.salesOrderJson?.TimelineEnabled ??
        this.salesOrderJson?.timeline_enabled;
      return ![false, 0, "0", "false", "False", "FALSE", "N", "n", "No", "NO", "no"].includes(timelineEnabled);
    },
    timelineStatusValue() {
      const timeline = this.timelineInfo();
      return this.normalizeTimelineStatus(timeline.TimelineStatus);
    },
    normalizeTimelineStatus(status) {
      const timelineStatus = String(status || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim()
        .toUpperCase();
      const compactStatus = timelineStatus.replace(/[\s-_]/g, "");
      if (compactStatus.includes("ONTIME")) return "ON-TIME";
      if (compactStatus.includes("MUSTSHIP")) return "MUST SHIP";
      if (compactStatus.includes("PASTDUE")) return "PAST DUE";
      return timelineStatus;
    },
    timelineStatusColorValue() {
      const timeline = this.timelineInfo();
      return timeline.TimelineColor || "";
    },
    timelineStatusBackgroundColor(backgroundColor) {
      const color = String(backgroundColor || "").trim();
      if (!color) return "#ECEFF1";
      const normalized = color.toLowerCase();
      const namedColors = {
        green: this.$vuetify.theme.dark ? "#A5D6A7" : "#2E7D32",
        red: this.$vuetify.theme.dark ? "#EF9A9A" : "#C62828",
        yellow: "#FFEB3B",
        orange: this.$vuetify.theme.dark ? "#FFCC80" : "#EF6C00",
        blue: this.$vuetify.theme.dark ? "#90CAF9" : "#1565C0",
        grey: this.$vuetify.theme.dark ? "#CFD8DC" : "#607D8B",
        gray: this.$vuetify.theme.dark ? "#CFD8DC" : "#607D8B",
      };
      if (namedColors[normalized]) return namedColors[normalized];
      const yellowValues = ["yellow", "#ffff00", "#ffc107", "#ffeb3b", "ffc107", "ffeb3b", "ffff00"];
      return yellowValues.includes(normalized) ? "#FFEB3B" : color;
    },
    timelineStatusTextColor(backgroundColor) {
      if (!backgroundColor) return "#263238";
      const normalized = String(backgroundColor).trim().toLowerCase();
      const yellowValues = ["yellow", "#ffff00", "#ffc107", "#ffeb3b", "ffc107", "ffeb3b", "ffff00"];
      if (yellowValues.includes(normalized)) return "#000000";
      let hex = String(backgroundColor).trim().replace("#", "");
      if (hex.length === 3) {
        hex = hex.split("").map((char) => char + char).join("");
      }
      if (!/^[0-9a-fA-F]{6}$/.test(hex)) return "#263238";
      const red = parseInt(hex.substring(0, 2), 16);
      const green = parseInt(hex.substring(2, 4), 16);
      const blue = parseInt(hex.substring(4, 6), 16);
      const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
      return luminance > 0.6 ? "#263238" : "#FFFFFF";
    },
    formatSalesOrderHistoryTime(date) {
      return date ? moment(date).format("h:mm:ss A") : "";
    },
    displayHistoryValue(value) {
      return value === null || value === undefined || String(value).trim() === "" ? "-" : value;
    },
    normalizeSalesOrderHistory(historyData) {
      const historyItems = historyData.ActionLogInfo || historyData.Data || (Array.isArray(historyData) ? historyData : []);
      return historyItems.map((item, index) => ({
        _idx: item.ChangeGroup || index,
        ChangeGroup: item.ChangeGroup,
        Changed: item.Changed || item.Logged,
        ChangedBy: item.ChangedBy || item.User || "",
        Action: item.Action || "",
        Entity: item.Entity || "",
        RecordCount: item.RecordCount,
        expanded: false,
        Changes: item.Changes?.length
          ? item.Changes
          : [{
            Field: item.Field || "",
            OldValue: item.OldValue || "",
            NewValue: item.NewValue || "",
          }],
      }));
    },
    buildSalesOrderHistoryRows(records) {
      return records.reduce((items, obj, groupIndex) => {
        const changes = obj.Changes?.length ? obj.Changes : [{}];
        changes.forEach((change, changeIndex) => items.push({
          _idx: `${groupIndex}-${changeIndex}`,
          ChangeGroup: obj.ChangeGroup,
          Changed: obj.Changed ? Utility.displayDateFormat(obj.Changed) : "",
          ChangedBy: obj.ChangedBy,
          Action: obj.Action,
          Entity: obj.Entity,
          RecordCount: obj.RecordCount,
          Field: change.Field || "",
          OldValue: change.OldValue || "",
          NewValue: change.NewValue || "",
        }));
        return items;
      }, []);
    },
    getHistoryLineDetails(value) {
      if (!value) return [];
      return String(value)
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean)
        .map((part) => {
          const splitIndex = part.indexOf("=");
          if (splitIndex === -1) return { label: "", value: part };
          return {
            label: part.substring(0, splitIndex).trim(),
            value: part.substring(splitIndex + 1).trim(),
          };
        });
    },
    historyChangeTitle(record) {
      const change = record.Changes?.[0] || {};
      const lineMatch = String(change.NewValue || "").match(/Line#(\d+)/);
      const lineLabel = lineMatch ? `Line #${lineMatch[1]}` : "Line";
      if (record.Action === "DELETE" && change.Field === "Line Deleted") return `${lineLabel} deleted`;
      if (record.Action === "ADD" && change.Field === "Line Added") return `${lineLabel} added`;
      if (record.Changes?.length > 1) return `${record.Changes.length} fields changed`;
      return change.Field || record.Entity;
    },
    isLineSummary(record) {
      const field = record.Changes?.[0]?.Field;
      return record.Changes?.length === 1 && (field === "Line Deleted" || field === "Line Added");
    },
    async getCommentsData() {
      let commentData = this.salesOrderJson?.comments
        ? JSON.parse(this.salesOrderJson?.comments).CommentsInfo
        : "";
      commentData?.forEach((element) => {
        element.name = element.username;
        element.date = Utility.displayDateFormat(element.modified_date);
      });
      this.commentList = commentData;
      this.tempCommentList = JSON.parse(JSON.stringify(this.commentList));
    },
    //to check if its a number of not
    isNumber(event, loc) {
      if (loc == "number") {
        let value = Utility.isNumber(event);
        return value;
      } else {
        let value = Utility.isNumberWithPeriod(event);
        return value;
      }
    },
    //Action List
    setActionFunction() {
      if (this.actionSetter("DeleteSalesOrder"))
        this.showActionsList.push({
          Id: "SO-Delete",
          Icon: "mdi-delete",
          FriendlyName: "SO Delete",
        }),
          this.showActionsList.push({
            Id: "SO-Reset",
            Icon: "mdi-refresh",
            FriendlyName: "Reset",
          });
    },
    // Action based
    actionSetter(action) {
      if (
        this.actionList !== undefined &&
        this.actionList !== null &&
        this.actionList !== ""
      ) {
        let filter = this.actionList?.filter(
          (entry) => entry.SystemName === action
        );
        return filter !== undefined && filter !== null && filter.length >= 1
          ? true
          : false;
      } else return false;
    },
    async loadSalesOrderHistory() {
      this.salesOrderHistoryRecords = [];
      this.salesOrderHistoryItems = [];
      let historyData = await salesService.getSalesOrderChangeLog(
        this.salesOrderId,
        this.userId
      );
      if (historyData !== null && historyData !== undefined && historyData?.message !== "NA") {
        const records = this.normalizeSalesOrderHistory(historyData);
        this.salesOrderHistoryRecords = records;
        this.salesOrderHistoryItems = this.buildSalesOrderHistoryRows(records);
      }
    },
    //Sales Order History button click event
    async salesOrderHistory() {
      this.activeSoDetailsTab = "order-history";
      await this.loadSalesOrderHistory();
    },
    // Fetch the current waybill tracking status shown below Shipped Date
    async getTrackingStatus() {
      let data = await salesOrderEditService.getSoTrackingWaybills("get", this.salesOrderId);
      this.trackingCurrentStatus = data?.Data?.[0]?.Current_Status || "";
    },
    // Waybill tracking Status link click event
    async onClickTrackingStatus() {
      let data = await salesOrderEditService.getSoTrackingWaybillHistory("get", this.salesOrderId);
      this.trackingWaybillHistoryItems = (data?.Data || []).map((item, index) => ({
        ...item,
        Date: item.Date ? Utility.displayDateFormat(item.Date) : "",
        _idx: index,
      }));
      this.trackingExpandedWaybills = [];
      this.trackingShowAllWaybills = [];
      this.trackingWaybillHistoryDialog = true;
    },
    //Yes button on the refresh popup click event
    refreshYesClick() {
      this.refreshDialog = false;
    },
    //No button on the refresh popup click event
    refreshNoClick() {
      this.refreshDialog = false;
    },
    //Get Customer Data
    // async getCustomerData() {
    //   if (this.custSearchKey) {
    //     this.custSearchKey = this.custSearchKey?.toUpperCase();
    //     if (this.custSearchKey.length > 2) {
    //       let obj = {
    //         UserId: parseInt(this.userId),
    //         proj_key: this.salesOrderJson.proj_id,
    //         SearchStr: this.custSearchKey,
    //         pass: 1, // DO not Delte
    //       };
    //       let resp = await salesOrderEditService.postCustomerData(
    //         "post",
    //         obj,
    //         false,
    //         true
    //       );
    //       if (resp?.CustomerInfo) {
    //         this.customerList = resp?.CustomerInfo?.map((x) => ({
    //           title: x.title,
    //           last: x.first + " " + x.last,
    //           cust_id: x.cust_id,
    //           custno: x.custno,
    //           company: x.company,
    //           address1: x.address1,
    //           address2: x.address2,
    //           city: x.city,
    //           state: x.state,
    //           zip: x.zip,
    //           country: x.country,
    //           phone1: x.phone1,
    //           phone2: x.phone2,
    //           cell: x.cell,
    //           email: x.email,
    //           fax: x.fax,
    //         }));
    //       }
    //       this.salesOrderJson.CustomerInfo = [
    //         {
    //           first: "",
    //           title: "",
    //           last: "",
    //           cust_id: "",
    //           custno: "",
    //           company: "",
    //           address1: "",
    //           address2: "",
    //           city: "",
    //           state: "",
    //           zip: "",
    //           country: "",
    //           phone1: "",
    //           phone2: "",
    //           cell: "",
    //           fax: "",
    //           email: "",
    //         },
    //       ];
    //     } else {
    //       this.clearCustAddressData();
    //     }
    //   }
    // },
    //Clear Customer address data
    clearCustAddressData() {
      (this.salesOrderJson.CustomerInfo = {
        first: "",
        title: "",
        last: "",
        cust_id: "",
        custno: "",
        company: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        phone1: "",
        phone2: "",
        cell: "",
        fax: "",
        email: "",
      }),
        (this.customerList = []);
      this.showAddress = false;
    },
    // Parent Nav function
    preventNav(event) {
      if (!this.isEditing) return;
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },
    //TO show Customer Data
    showCustomer(item) {
      Object.assign(this.salesOrderJson?.CustomerInfo[0], item);
      this.custSearchKey = item.company;
      this.customerList = [];
    },
    // To get the Ship
    async getShipData() {
      if (this.shipSearchKey) {
        this.shipSearchKey = this.shipSearchKey?.toUpperCase();
        if (this.shipSearchKey.length > 2) {
          let obj = {
            UserId: this.userId,
            proj_key: this.salesOrderJson.proj_id,
            SearchStr: this.shipSearchKey,
            pass: 2, // Do not Delete
          };
          let resp = await salesOrderEditService.postCustomerData(
            "post",
            obj,
            false,
            true
          );
          if (resp?.CustomerInfo) {
            this.shipList = resp.CustomerInfo?.map((x) => ({
              sh_address1: x.sh_address1,
              sh_address2: x.sh_address2,
              sh_cell: x.sh_cell?.trim(),
              sh_city: x.sh_city,
              sh_company: x.sh_company,
              sh_country: x.sh_country,
              sh_custno: x.sh_custno,
              sh_cust_id: x.sh_cust_id,
              sh_email: x.sh_email,
              sh_fax: x.sh_fax?.trim(),
              sh_first: x.sh_first,
              sh_last: x.sh_last,
              sh_phone1: x.sh_phone1?.trim(),
              sh_phone2: x.sh_phone2?.trim(),
              sh_state: x.sh_state,
              sh_title: x.sh_title,
              sh_zip: x.sh_zip,
            }));
          }
        } else {
          this.clearShipAddressData();
        }
      }
    },
    //clear Ship address
    clearShipAddressData() {
      this.shipList = [];
      this.showShipAddress = false;
      this.sameAsCust = false;
    },
    // On part Number to Return
    onPartReturnChange(warehouse_id) {
      let returnShipObj = this.returnWareList?.filter(
        (x) => x.ware_id == warehouse_id
      );
      this.temp_order_line.return_to_inventory_bucket = returnShipObj[0].bucket;
      this.temp_order_line.return_to_warehouse = returnShipObj[0].ware;
      this.temp_order_line.return_to_warehouse_id = returnShipObj[0].ware_id;
    },
    // to show Address
    showShip(item) {
      Object.assign(this.salesOrderJson.shipment_address[0], item);
      this.shipSearchKey = item.sh_company;
      if (this.shipSearchKey) this.selectedShip = true;
      this.shipList = [];
    },
    // To get Return Data
    async getReturnData() {
      if (this.returnSearchKey) {
        this.returnSearchKey = this.returnSearchKey?.toUpperCase();
        if (this.returnSearchKey.length > 2) {
          let returnData = await salesOrderEditService.getReturnAddData(
            "get",
            this.userId,
            this.salesOrderJson.proj_id,
            this.returnSearchKey,
            this.salesOrderJson.bu_id,
            "",
            false,
            true,
            1
          );
          if (returnData?.ReturnAddress) this.showReturnAddDDL = true;
          this.returnList = returnData.ReturnAddress?.map((x) => ({
            rt_address1: x.rt_address1,
            rt_address2: x.rt_address2,
            rt_cell: x.rt_cell?.trim(),
            rt_city: x.rt_city,
            rt_company: x.rt_company,
            rt_country: x.rt_country,
            rt_custno: x.rt_custno,
            rt_comp_id: x.rt_comp_id,
            rt_email: x.rt_email,
            rt_fax: x.rt_fax?.trim(),
            rt_first: x.rt_first,
            rt_last: x.rt_last,
            rt_phone1: x.rt_phone1?.trim(),
            rt_phone2: x.rt_phone2?.trim(),
            rt_state: x.rt_state,
            rt_title: x.rt_title,
            rt_zip: x.rt_zip,
          }));
        } else {
          this.clearReturnAddressData();
        }
      }
    },
    // to show Address
    showReturn(item) {
      this.showReturnAddress = true;
      Object.assign(this.salesOrderJson.return_address[0], item);
      this.returnSearchKey = item.rt_company;
      this.selectedReturn = true;
      this.$refs.addressForm?.resetValidation();

      this.returnList = [];
    },
    //clear Ship address
    clearReturnAddressData() {
      this.returnList = [];
      this.showReturnAddress = false;
    },

    //Getting the data back from Compoents based on val flag we will call the respsective APIs and but the address
    async addAddress(custObj, val) {
      if (val == "customer") {
        {
          let obj = {
            CuJson: JSON.stringify(custObj),
            pass: 1, //Do not remove
          };
          let res = await salesService.postAddCustomer("post", obj, true);
          Object.assign(this.salesOrderJson?.CustomerInfo[0], custObj);
          this.salesOrderJson.CustomerInfo[0].cust_id = res?.Result[0].Cust_Id; // DO not Remove
        }
        this.showCustomerDialog = false;
        this.showAddress = true;
      }
      // new ship is added
      else if (val == "ship") {
        let obj = {
          CuJson: JSON.stringify(custObj),
          pass: 2, // DO not Remove
        };
        let res = await salesService.postAddCustomer("post", obj, true);
        this.salesOrderJson.shipment_address[0].cust_id = res.Result[0].Cust_Id;
        this.salesOrderJson.shipment_address[0].sh_title = custObj.title;
        this.salesOrderJson.shipment_address[0].sh_first = "";
        this.salesOrderJson.shipment_address[0].sh_last =
          custObj.first + " " + custObj.last;
        this.salesOrderJson.shipment_address[0].sh_cust_id = custObj.cust_id;
        this.salesOrderJson.shipment_address[0].sh_custno = custObj.custno;
        this.salesOrderJson.shipment_address[0].sh_company = custObj.company;
        this.salesOrderJson.shipment_address[0].sh_address1 = custObj.address1;
        this.salesOrderJson.shipment_address[0].sh_address2 = custObj.address2;
        this.salesOrderJson.shipment_address[0].sh_city = custObj.city;
        this.salesOrderJson.shipment_address[0].sh_state = custObj.state;
        this.salesOrderJson.shipment_address[0].sh_zip = custObj.zip;
        this.salesOrderJson.shipment_address[0].sh_country = custObj.country;
        this.salesOrderJson.shipment_address[0].sh_phone1 = custObj.phone1;
        this.salesOrderJson.shipment_address[0].sh_phone2 = custObj.phone2;
        this.salesOrderJson.shipment_address[0].sh_cell = custObj.cell;
        this.salesOrderJson.shipment_address[0].sh_email = custObj.email;
        this.salesOrderJson.shipment_address[0].sh_fax = custObj.fax;
        this.salesOrderJson.shipment_address[0].sh_additional_email = custObj.additional_email || '';
        this.showShipToDialog = false;
      }
      // if new return is addes
      else if (val == "return") {
        let obj = {
          CuJson: JSON.stringify(custObj),
        };
        let returnres = await salesService.postAddReturnAddress(
          "post",
          obj,
          true
        );
        this.salesOrderJson.return_address[0].comp_id =
          returnres.Result[0].comp_id; // DO not delete
        this.salesOrderJson.return_address[0].rt_title = custObj.title;
        this.salesOrderJson.return_address[0].rt_first = "";
        this.salesOrderJson.return_address[0].rt_last =
          custObj.first + " " + custObj.last;
        this.salesOrderJson.return_address[0].rt_comp_id = custObj.cust_id;
        this.salesOrderJson.return_address[0].rt_custno = custObj.custno;
        this.salesOrderJson.return_address[0].rt_company = custObj.company;
        this.salesOrderJson.return_address[0].rt_address1 = custObj.address1;
        this.salesOrderJson.return_address[0].rt_address2 = custObj.address2;
        this.salesOrderJson.return_address[0].rt_city = custObj.city;
        this.salesOrderJson.return_address[0].rt_state = custObj.state;
        this.salesOrderJson.return_address[0].rt_zip = custObj.zip;
        this.salesOrderJson.return_address[0].rt_country = custObj.country;
        this.salesOrderJson.return_address[0].rt_phone1 = custObj.phone1?.trim();
        this.salesOrderJson.return_address[0].rt_phone2 = custObj.phone2?.trim();
        this.salesOrderJson.return_address[0].rt_cell = custObj.cell?.trim();
        this.salesOrderJson.return_address[0].rt_email = custObj.email?.trim();
        this.salesOrderJson.return_address[0].rt_fax = custObj.fax?.trim();
        this.showReturnToDialog = false;
        this.showReturnAddress = true;
      }
      // If user edits the address for just this order
      else if (val == "shipEdit") {
        this.salesOrderJson.shipment_address[0].sh_title = custObj.title;
        this.salesOrderJson.shipment_address[0].sh_first = "";
        this.salesOrderJson.shipment_address[0].sh_last =
          custObj.first + " " + custObj.last;
        this.salesOrderJson.shipment_address[0].sh_cust_id = custObj.cust_id;
        this.salesOrderJson.shipment_address[0].sh_custno = custObj.custno;
        this.salesOrderJson.shipment_address[0].sh_company = custObj.company;
        this.salesOrderJson.shipment_address[0].sh_address1 = custObj.address1;
        this.salesOrderJson.shipment_address[0].sh_address2 = custObj.address2;
        this.salesOrderJson.shipment_address[0].sh_city = custObj.city;
        this.salesOrderJson.shipment_address[0].sh_state = custObj.state;
        this.salesOrderJson.shipment_address[0].sh_zip = custObj.zip;
        this.salesOrderJson.shipment_address[0].sh_country = custObj.country;
        this.salesOrderJson.shipment_address[0].sh_phone1 = custObj.phone1?.trim();
        this.salesOrderJson.shipment_address[0].sh_phone2 = custObj.phone2?.trim();
        this.salesOrderJson.shipment_address[0].sh_cell = custObj.cell?.trim();
        this.salesOrderJson.shipment_address[0].sh_email = custObj.email?.trim();
        this.salesOrderJson.shipment_address[0].sh_additional_email = custObj.additional_email;
        this.salesOrderJson.shipment_address[0].sh_fax = custObj.fax?.trim();
        this.showEditShipToDialog = false;
      }
      // if Return edit is created from Address Comp
      else if (val == "returnEdit") {
        this.salesOrderJson.return_address[0].sh_title = custObj.title;
        this.salesOrderJson.return_address[0].rt_first = "";
        this.salesOrderJson.return_address[0].rt_last =
          custObj.first + " " + custObj.last;
        this.salesOrderJson.return_address[0].rt_cust_id = custObj.cust_id;
        this.salesOrderJson.return_address[0].rt_custno = custObj.custno;
        this.salesOrderJson.return_address[0].rt_company = custObj.company;
        this.salesOrderJson.return_address[0].rt_address1 = custObj.address1;
        this.salesOrderJson.return_address[0].rt_address2 = custObj.address2;
        this.salesOrderJson.return_address[0].rt_city = custObj.city;
        this.salesOrderJson.return_address[0].rt_state = custObj.state;
        this.salesOrderJson.return_address[0].rt_zip = custObj.zip;
        this.salesOrderJson.return_address[0].rt_country = custObj.country;
        this.salesOrderJson.return_address[0].rt_phone1 = custObj.phone1?.trim();
        this.salesOrderJson.return_address[0].rt_phone2 = custObj.phone2?.trim();
        this.salesOrderJson.return_address[0].rt_cell = custObj.cell?.trim();
        this.salesOrderJson.return_address[0].rt_email = custObj.email?.trim();
        this.salesOrderJson.return_address[0].rt_fax = custObj.fax?.trim();
        this.showEditReturnToDialog = false;
      }
    },
    // on Click open the Dialog Dialog of build order tables
    OnClickEditBuildFlex(item, buildOrderEditShow) {
      if (buildOrderEditShow == "buildOrderEditShow") {
        this.editListFlex = false;
        this.editWaybillShow = false;
        this.showEditBuild = true;
        this.editPartQty = item.bo_qty;
        this.editPartNum = item.bo_part_number;
        this.editPartDesc = item.bo_part_description;
        this.build_id = item.build_id;
        this.buildRow = true;
      } else if (buildOrderEditShow == "editWaybillShow") {
        this.buildRow = false;
        this.editListFlex = false;
        this.editWaybillShow = true;
        this.showEditBuild = true;
        this.editSerialNum = item.serial_number;
        this.editAssetTag = item.asset_tag;
        this.sequence_number = item.sequence_number;
        this.editProblemDesc = item.problem_description;
        this.editWarrantyStatus = item.warranty_status;
        this.editTrack = item.return_tracking_number;
        this.editReturn_carrier = item.return_carrier;
        this.temp_waybill_id = item.temp_waybill_id;
      } else if (buildOrderEditShow == "editListFlex") {
        this.buildRow = false;
        this.editListFlex = true;
        this.editWaybillShow = false;
        this.showEditBuild = true;
        this.sequence_number = item.temp_flex_id;
        this.list_flex_field_Att = item.flex_code;
        this.list_flex_value = item.flex_data;
      }
    },
    // On Add Flex
    onClickFlexAdd(flex_field_Att, flex_value) {
      if (this.$refs.flexForm?.validate()) {
        let order_line_num =
          this.salesOrderJson.order_line.length == null ||
          this.salesOrderJson.order_line.length == undefined
            ? 0
            : this.salesOrderJson.order_line.length;
        // if show parts item is true that means this add flex is for line Item
        if (this.showPartsItem) {
          let flx_ord_seq =
            this.temp_order_line.flex_field.length == undefined ||
            this.temp_order_line.flex_field.length == null
              ? 0
              : this.temp_order_line.flex_field.length;
          let obj = {
            temp_flex_id: flx_ord_seq + 1,
            sequence_number: order_line_num + 1,
            flex_code: flex_field_Att,
            flex_data: flex_value,
            is_Added: true,
            is_Deleted: false,
          };
          this.temp_order_line.flex_field.push(obj);
        }
        // this flex is for main flex
        else {
          let flxseq =
            this.salesOrderJson.flex_field.length == undefined ||
            this.salesOrderJson.flex_field.length == null
              ? 0
              : this.salesOrderJson.flex_field.length;
          let obj = {
            sequence_number: flxseq + 1,
            flex_code: flex_field_Att,
            flex_data: flex_value,
            soflex_id: 0,
            is_Added: true,
            is_Deleted: false,
          };
          this.salesOrderJson.flex_field.push(obj);
          this.flexDisplayList.push(obj);
        }
        this.showFlexDialog = false;
        this.flex_field_Att = "";
        this.flex_value = "";
        this.$refs.flexForm?.resetValidation();
      }
    },
    clearFlexItem() {
      this.showFlexDialog = false;
      this.flex_field_Att = "";
      this.flex_value = "";
      this.$refs.flexForm?.resetValidation();
    },
    // To Get Flex Details
    flexDetails(item) {
      this.buildRow = false;
      this.editFlex = true;
      this.editListFlex = false;
      this.editWaybillShow = false;
      this.showEditBuild = true;
      this.sequence_number = item.temp_flex_id
        ? item.temp_flex_id
        : item.sequence_number;
      this.list_flex_field_Att = item.flex_code;
      this.list_flex_value = item.flex_data;
    },
    //  Delete Flex
    deleteFlex() {
      this.temp_order_line.flex_field =
        this.temp_order_line?.flex_field?.filter(
          (x) => x.temp_flex_id !== this.sequence_number
        );
      this.showEditBuild = false;
      this.deleteBuildDialog = false;
    },
    // Delete Flex which is ouside line Items
    deleteJSONFlex() {
      this.salesOrderJson.flex_field.find(
        (v) => v.sequence_number === this.sequence_number
      ).is_Deleted = true;
      if (
        this.salesOrderJson.flex_field?.find(
          (v) => v.sequence_number === this.sequence_number
        ).is_Deleted &&
        this.salesOrderJson.flex_field?.find(
          (v) => v.sequence_number === this.sequence_number
        ).is_Added
      ) {
        this.salesOrderJson.flex_field = this.salesOrderJson.flex_field?.filter(
          (x) => x.sequence_number !== this.sequence_number
        );
      }
      this.showEditBuild = false;
      this.deleteBuildDialog = false;
      this.flexDisplayList = this.flexDisplayList?.filter(
        (x) => x.sequence_number !== this.sequence_number
      );
    },
    // Update flex
    onClickUpdateFlex(list_flex_field_Att, list_flex_value) {
      if (this.$refs.EditflexForm?.validate()) {
        // if show parts item is true the it will fill json flex or else it will update line item's flex
        if (!this.showPartsItem) {
          this.flexDisplayList = this.flexDisplayList?.map((p) =>
            p.sequence_number == this.sequence_number
              ? {
                  ...p,
                  flex_code: list_flex_field_Att,
                  flex_data: list_flex_value,
                }
              : p
          );
          this.salesOrderJson.flex_field = this.salesOrderJson.flex_field?.map(
            (p) =>
              p.sequence_number == this.sequence_number
                ? {
                    ...p,
                    flex_code: list_flex_field_Att,
                    flex_data: list_flex_value,
                  }
                : p
          );
        } else {
          this.temp_order_line.flex_field =
            this.temp_order_line.flex_field?.map((p) =>
              p.temp_flex_id == this.sequence_number
                ? {
                    ...p,
                    flex_code: list_flex_field_Att,
                    flex_data: list_flex_value,
                  }
                : p
            );
        }
        this.showEditBuild = false;
      }
    },
    //close part ITem
    closePartItem() {
      this.showPartsItem = false;
      this.showLineDelete = false;
      this.showExpectedSr = false;
      this.clearPartItem();
    },
    // Clear Part Item
    clearPartItem() {
      this.lineItemPanel = [0, 1];
      this.showPartDetails = false;
      this.buildPartNumList = false;
      this.showPartShipDetails = false;
      this.showPartRetDetails = false;
      this.disableQty = false;
      this.buildOrderList = [];
      this.expected_serial_number_list = [];
      this.disableRetQty = false;
      this.greaterThanRule = [];
      this.greaterThanRuleRet = [];
      this.greaterThanValid = false;
      this.greaterThanValidRet = false;
      this.showConvertBtn = false;
      this.showForceBtn = false;
      this.returnPartNum = "";
      this.returnPartDesc = "";
      this.showLineDelete = false;
      this.showConevertDropDown = false;
      this.showBuildExpand = false;
      this.showStockStatus = false;
      this.showPriceInfo = false;
      this.disablePartRecieve = false;
      this.stockMessage = "";
      this.serial_num = "";
      this.asset_tag = "";
      this.problem_desc = "";
      this.warr_status = "N";
      this.tracking_num = "";
      this.return_carrier = "";
      this.enableEdit = true;
      this.temp_order_line = {
        sequence_number: "",
        order_line_type: "",
        line_number: "",
        sh_part_id: "",
        sh_part_number: "",
        sh_part_description: "",
        sh_from_warehouse_id: "",
        sh_from_warehouse: "",
        sh_from_inventory_bucket: "",
        sh_quantity: "",
        sh_price: (0).toFixed(2),
        build_orders: {
          build_order_notes: "",
          build_order: [],
        },
        return_part_id: "",
        return_part_number: "",
        return_part_description: "",
        return_to_warehouse_id: "",
        return_to_warehouse: "",
        return_to_inventory_bucket: "",
        return_quantity: "",
        return_price: "",
        expected_serial_number: [],
        line_comment: "",
        flex_field: [],
        is_FAllocated: false,
        is_Converted: false,
      };
      this.sameAsShip = false;
      this.shipPartName = "";
      this.partBuildPartNum = "";
      this.buildToQty = "";
      this.shipPartDesc = "";
      this.partShipSearchKey = "";
      this.partReturnSearchKey = "";
      this.disableLine = false;
      this.showPartShip = false;
      this.showPartRet = false;
      this.showFlex = false;
      this.showexpIcon = false;
      this.showBuildIcon = false;
    },
    // To clean part number once its click on cancel
    clearPartShip() {
      this.$refs?.PartShipForm?.resetValidation();
      this.shipPartName = "";
      this.shipPartDesc = "";
      this.temp_order_line.sh_price = "";
      this.temp_order_line.sh_quantity = "";
      this.temp_order_line.sh_from_warehouse_id = "";
      this.showPartDetails = false;
      this.disableQty = false;
      this.showBuildIcon = false;
      this.showStockStatus = false;
      this.showPriceInfo = false;
      this.temp_order_line.build_orders.build_order = [];
      this.showBuildExpand = false;
      this.temp_order_line.build_orders.build_order_notes = "";
      this.shipWareList = [];
      this.temp_order_line.sh_from_warehouse = "";
      this.temp_order_line.sh_from_inventory_bucket = "";
      this.temp_order_line.sh_part_id = "";
      this.disablePartShip = false;
    },
    // Clear Part Return Items
    clearPartReturn() {
      this.$refs?.PartRecieveForm?.resetValidation();
      this.temp_order_line.return_part_number = "";
      this.temp_order_line.return_part_description = "";
      this.temp_order_line.return_price = "";
      this.temp_order_line.return_quantity = "";
      this.temp_order_line.return_to_inventory_bucket = "";
      this.temp_order_line.return_to_warehouse = "";
      this.temp_order_line.return_to_warehouse_id = "";
      this.temp_order_line.return_part_id = "";
      this.returnWareList = [];
      this.expected_serial_number = [];
    },
    // Validation based of Line Type CHeck
    validateLineType() {
      //User to find Unique items in an array;
      let lineItemUsedObj = this.salesOrderJson.order_list.reduce(
        (acc, cur) => {
          acc[cur.order_line_type] = true;
          return acc;
        },
        {}
      );
      let lineTypeListObj = this.lineTypeList.reduce((acc, cur) => {
        acc[cur.so_type_id] = cur;
        return acc;
      }, {});
      Object.keys(lineTypeListObj)?.forEach((key) => {
        if (lineItemUsedObj[key]) {
          this.shippingReq =
            this.shippingReq || Boolean(lineTypeListObj[key].to_ship);
          this.returnReq = this.returnReq || !!lineTypeListObj[key].to_return;
        }
      });
    },
    //New Line Item
    async LineTypeData(item="", isAddLine=true) {
      this.isAddLine = isAddLine;
      let LineTypeData = await salesOrderEditService.getOrderTypeData(
        "get",
        this.userId,
        this.salesOrderJson.proj_id,
        this.salesOrderId,
        this.isAddLine
      );
      if (LineTypeData?.LineTypeInfo) {
        this.lineTypeList = LineTypeData.LineTypeInfo?.map((x) => ({
          so_type_id: x.sotype_id,
          so_desc: x.so_desc,
          so_type: x.so_type,
          to_ship: x.to_ship,
          to_return: x.to_return,
          to_disable_quantity: x.to_disable_quantity_edit,
          to_disable_ReturnSel: x.to_disable_ReturnSel,
        }));
        this.validateLineType();
        this.outboundOrderLine();
      }
      if (LineTypeData?.ConvertLineInfo) {
        this.convertedList = LineTypeData?.ConvertLineInfo?.filter(
          (x) => x.sotype_id == this.temp_order_line.order_line_type
        );
        if (
          this.convertedList.length > 0 &&
          !this.temp_order_line.is_Converted &&
          !this.temp_order_line.is_FAllocated &&
          this.temp_order_line.showConvertBtn
        ) {
          this.temp_order_line.showConvertBtn = true;
        } else {
          this.temp_order_line.showConvertBtn = false;
        }
      }
      if (item != "") {
        let obj = this.lineTypeList?.filter(
        (x) => x.so_type_id == item?.order_line_type
      );
      this.showPartShip = obj[0]?.to_ship == 1 ? true : false;
      this.showPartRet = obj[0]?.to_return == 1 ? true : false;
      if (obj.so_type_id == 6) {
        this.disablePartRecieve = true;
      }
      if (!this.temp_order_line.is_Edited) {
        this.showPartShip = obj[0]?.to_ship == 1 ? true : false;
        this.showPartRet = obj[0]?.to_return == 1 ? true : false;
      }
      // if (this.showPartShip && this.showPartRet){ this.disableRetQty =  obj[0]?.to_disable_quantity}
      // else if (!this.showPartShip && this.showPartRet)
      //   this.disableRetQty = false;

      this.disableRetQty =  obj[0]?.to_disable_quantity == 1 ? true : false;
      this.showFlex = true;
      this.temp_order_line.showPartShip = this.showPartShip;
      this.temp_order_line.showPartRet = this.showPartRet;
      this.showFlex = true;
      this.edit_line_num = item?.line_number;
      this.partShipSearchKey = item?.sh_part_number;
      this.shipPartName = item?.sh_part_number;
      this.shipPartDesc = item?.sh_part_description;
      this.partReturnSearchKey = item?.return_part_number;
      this.returnPartNum = item?.return_part_number;
      this.returnPartDesc = item.return_part_description;
      //Ship Object
      let shipWareObj = {
        part_num: this.temp_order_line.sh_part_number
          ? this.temp_order_line.sh_part_number
          : this.temp_order_line.return_part_number,
        order_type: this.salesOrderJson.order_type,
        sotype_key: this.temp_order_line.converted_to
          ? this.temp_order_line.converted_to
          : this.temp_order_line.order_line_type,
        order_bu_key: this.salesOrderJson.bu_id,
        line_id: 0, //Do not Delete
        so_key: this.salesOrderJson.so_id, //DO not Delete
        UserId: this.userId,
      };
      let shipWarehouseList = await salesOrderEditService.postShipWareData(
        "post",
        shipWareObj
      );
      this.showBuildIcon = shipWarehouseList.Result2[0]?.enable_build_sheet;
      this.showexpIcon = shipWarehouseList.Result2[0]?.enable_expected_sn;
      // this.showBuildIcon = true // DO no Delete
      if (shipWarehouseList?.ShipFromWare) {
        this.shipWareList = shipWarehouseList.ShipFromWare?.map((x) => ({
          ware: x.ware,
          ware_id: x.ware_id + "_" + x.bucket,
          bucket: x.bucket,
          from_warebuck: x.from_warebuck,
          show_text: x.show_text,
          mess_bit: x.mess_bit,
          fix_price: x.fix_price || 0,
          last_price: x.last_price || 0,
          avg_cost: x.avg_cost || 0,
        }));
      }
      if (this.showPartRet && this.temp_order_line?.return_part_number) {
        let returnObj = {
          part_num: this.temp_order_line.return_part_number,
          order_type: this.salesOrderJson.order_type,
          sotype_key: this.temp_order_line.converted_to
            ? this.temp_order_line.converted_to
            : this.temp_order_line.order_line_type,
          order_bu_key: this.salesOrderJson.bu_id,
          line_id: 0, //Do not Delete
          so_key: this.salesOrderJson.so_id, //DO not Delete
          UserId: this.userId,
        };
        let returnWareData = await salesOrderEditService.postShipWareData(
          "post",
          returnObj
        );
        if (returnWareData?.ReturnToWare != "") {
          this.returnWareList = returnWareData.ReturnToWare.map((x) => ({
            ware: x.ware,
            ware_id: x.ware_id + "_" + x.bucket,
            bucket: x.bucket,
            into_warebuck: x.into_warebuck,
          }));
        }
      }
      this.temp_order_line.sh_from_warehouse_id =
        this.temp_order_line.sh_from_warehouse_id +
        "_" +
        this.temp_order_line.sh_from_inventory_bucket;
      this.temp_order_line.return_to_warehouse_id =
        this.temp_order_line.return_to_warehouse_id +
        "_" +
        this.temp_order_line.return_to_inventory_bucket;
      let shippedPartData = this.shipWareList?.filter(
        (x) => x.ware_id == this.temp_order_line.sh_from_warehouse_id
      );
      this.showStockStatus = shippedPartData[0]?.mess_bit;
      this.stockMessage = shippedPartData[0]?.show_text;
      this.fix_price = shippedPartData[0]?.fix_price || 0;
      this.last_price = shippedPartData[0]?.last_price || 0;
      this.avg_cost = shippedPartData[0]?.avg_cost || 0;
      this.showPriceInfo = true;
      // Part number API to show the Build Icon or not
      if (!item?.is_Added) {
        this.temp_order_line.showConvertBtn =
          this.temp_order_line.showConvertBtn &&
          this.temp_order_line.enable_convertL;
        this.temp_order_line.showForceBtn =
          this.temp_order_line.showForceBtn &&
          this.temp_order_line.enable_fallocate;
      } else {
        this.temp_order_line.showConvertBtn = false;
        this.temp_order_line.showForceBtn = false;
      }
      if (this.temp_order_line?.build_orders?.build_order.length > 0)
        this.showBuildExpand = true;
      else this.showBuildExpand = false;
      if (this.temp_order_line?.expected_serial_number.length > 0)
        this.showExpectedSr = true;
      // Part number to ship qty validations
      this.temp_order_line["shipTempQty"] = this.temp_order_line.sh_quantity;
      this.temp_order_line["returnTempQty"] =
        this.temp_order_line.return_quantity;
      this.tempOrderLineBackup = JSON.parse(
        JSON.stringify(this.temp_order_line)
      );
      if (
        this.temp_order_line.Picked !== 0 ||
        this.temp_order_line.Shipped !== 0
      ) {
        this.greaterThanValid = true;
        this.greaterVal = Math.max(
          this.temp_order_line.Picked,
          this.temp_order_line.Shipped
        );
        // Rules for Validation
        this.greaterThanRule.push(
          (v) => parseInt(v) > 0 || "Qty should be greater than 0",
          (v) =>
            parseInt(v) <= this.temp_order_line.sh_quantity ||
            `Qty should be less than equals to ${this.temp_order_line.sh_quantity}`,
          (v) =>
            parseInt(v) >= this.greaterVal ||
            "Qty cannot be less than " + this.greaterVal
        );
      }

      // this is for Part number to receive
      if (!this.showPartShip && this.showPartRet) {
        this.greaterThanValidRet = true;
        this.greaterValRet = this.temp_order_line.Rcvd;
        // Rules for Validation
        this.greaterThanRuleRet.push(
          (v) => parseInt(v) > 0 || "Qty should be greater than 0",
          (v) =>
            parseInt(v) >= this.greaterValRet ||
            "Qty cannot be less than " + this.greaterValRet
        );
      }
      if (this.showPartShip && this.showPartRet) {
        this.greaterThanValidRet = true;
        this.greaterThanRuleRet.push(
          (v) => parseInt(v) > 0 || "Qty should be greater than 0",
          (v) =>
            parseInt(v) <= parseInt(this.temp_order_line.sh_quantity) ||
            `Return Qty cannot be greater than ship quantity ${this.temp_order_line.sh_quantity}`
        );
        if (this.temp_order_line.Shipped > 0) {
          this.greaterThanRuleRet.push(
            (v) =>
              parseInt(v) <= this.temp_order_line.Shipped ||
              `Return Qty cannot exceed shipped quantity ${this.temp_order_line.Shipped}`
          );
          if (this.temp_order_line.Rcvd > 0) {
            this.greaterThanRuleRet.push(
              (v) =>
                parseInt(v) >= this.temp_order_line.Rcvd ||
                `Return Qty cannot be less than received quantity ${this.temp_order_line.Rcvd}`
            );
          }
        }
      }
      this.temp_order_line["order_line_text"] = item.order_line_text;}
    },
    // To get warrenty Data
    async warrentyData() {
      let warrentyListData = await salesOrderEditService.getWarrentyData(
        "get",
        this.userId
      );
      if (warrentyListData != "") {
        this.warrentyList = warrentyListData.WarrantyData;
      }
    },
    // On click of Add List
    async onClickAddList() {
      if (this.isShippingHold) return;
      this.disableQty = true;
      this.enableEdit = false;
      this.temp_order_line.enable_save = false;
      this.LineTypeData();
      this.showPartsItem = true;
      this.clearPartItem();
      this.temp_order_line.is_FAllocated = true;
      this.warrentyData();
    },
    //Get Part Number Ship Data
    //Get Ship  Data
    async partShipData() {
      if (this.partShipSearchKey) {
        this.clearPartShip();
        this.partShipSearchKey = this.partShipSearchKey?.toUpperCase();
        if (this.partShipSearchKey.length > 2) {
          this.showPartShipDetails = true;
          let shipDataObj = {
            UserId: this.userId,
            SearchStr: this.partShipSearchKey,
            BuKey: this.salesOrderJson.bu_id,
            order_type: this.salesOrderJson.order_type,
          };
          let shipDataSearch = await salesOrderEditService.postShipSearch(
            "post",
            shipDataObj,
            false,
            true
          );
          if (shipDataSearch?.Resultset)
            this.partResultList = shipDataSearch.Resultset;
          else this.clearPartShip();
        } else {
          this.clearPartShip();
        }
      }
    },
    //Show Part Number Details
    async showPartDesc(item) {
      this.partResultList = [];
      this.showPartDetails = true;
      this.showBuildExpand = false;
      this.buildOrderList = [];
      this.temp_order_line.build_orders.build_order = [];
      this.temp_order_line.sh_part_id = item.part_id;
      this.temp_order_line.sh_price = (0).toFixed(2);
      this.temp_order_line.sh_part_number = item.part_num;
      this.temp_order_line.sh_part_description = item.part_desc;
      this.shipPartName = item.part_num;
      this.partShipSearchKey = item.part_num;
      this.shipPartDesc = item.part_desc;
      this.shipPartKey = item.part_id;
      let shipWareObj = {
        part_num: item.part_num,
        order_type: this.salesOrderJson.order_type,
        sotype_key: this.temp_order_line.converted_to
          ? this.temp_order_line.converted_to
          : this.temp_order_line.order_line_type,
        order_bu_key: this.salesOrderJson.bu_id,
        line_id: 0, //Do not Delete
        so_key: 0, //DO not Delete
        UserId: this.userId,
      };
      this.disableQty = false;
      let shipWarehouseList = await salesService.postShipWareData(
        "post",
        shipWareObj
      );
      this.showBuildIcon = shipWarehouseList.Result2[0]?.enable_build_sheet;
      this.showexpIcon = shipWarehouseList.Result2[0]?.enable_expected_sn;
      // this.showBuildIcon = true // DO no Delete
      this.temp_order_line.showBuild = this.showBuildIcon;
      if (this.showLineDelete) {
        this.temp_order_line.sh_price = parseInt(
          shipWarehouseList.Result1[0].defaultprice
        );
      }
      this.temp_order_line.showSerial = this.showexpIcon;
      if (shipWarehouseList?.ShipFromWare) {
        this.shipWareList = shipWarehouseList.ShipFromWare?.map((x) => ({
          ware: x.ware,
          ware_id: x.ware_id + "_" + x.bucket,
          bucket: x.bucket,
          from_warebuck: x.from_warebuck,
          mess_bit: x.mess_bit,
          show_text: x.show_text,
          fix_price: x.fix_price || 0,
          last_price: x.last_price || 0,
          avg_cost: x.avg_cost || 0,
        }));
        this.fix_price = shipWarehouseList.ShipFromWare[0]?.fix_price || 0;
        this.last_price = shipWarehouseList.ShipFromWare[0]?.last_price || 0;
        this.avg_cost = shipWarehouseList.ShipFromWare[0]?.avg_cost || 0;
      }
      if (shipWarehouseList?.ReturnToWare != "") {
        this.returnWareList = shipWarehouseList.ReturnToWare?.map((x) => ({
          ware: x.ware,
          ware_id: x.ware_id + "_" + x.bucket,
          bucket: x.bucket,
          into_warebuck: x.into_warebuck,
        }));
        if (this.disablePartRecieve) {
          this.partReturnSearchKey = this.partShipSearchKey;
          this.temp_order_line.return_part_number =
            this.temp_order_line.sh_part_number;
          this.temp_order_line.return_quantity =
            this.temp_order_line.sh_quantity;
          this.temp_order_line.return_part_description =
            this.temp_order_line.sh_part_description;
          this.temp_order_line.return_part_id = this.temp_order_line.sh_part_id;
        }
      }
    },
    //Part Number for Build Order
    async buildPartNum() {
      if (this.partBuildPartNum) {
        this.partBuildPartNum = this.partBuildPartNum?.toUpperCase();
        if (this.partBuildPartNum.length > 2) {
          this.buildPartNumList = true;
          let shipDataObj = {
            UserId: this.userId,
            SearchStr: this.partBuildPartNum,
            BuKey: this.salesOrderJson.bu_id,
            order_part_key: parseInt(this.shipPartKey),
          };
          let buildorderListData = await salesOrderEditService.postBuildData(
            "post",
            shipDataObj,
            false,
            true
          );
          if (buildorderListData?.Resultset) {
            this.buildPartResultList = buildorderListData.Resultset;
          } else {
            this.partBuildPartNum = "";
          }
        }
      }
    },
    // Show Bulilf Part Number Deatils in Dropdown
    showBuildPartDesc(item) {
      this.disableBuildSave = false;
      this.partBuildPartNum = item.part_num;
      this.buildPartResultList = [];
      this.buildPartId = item.part_id;
      this.buildObj = item;
    },
    // on Save Build Part Number
    onClickSaveBuild(buildToQty) {
      this.disableBuildSave = true;
      if (this.$refs.BuildForm?.validate()) {
        let build_id =
          this.temp_order_line.build_orders.build_order.length == undefined ||
          this.temp_order_line.build_orders.build_order == null
            ? 0
            : this.temp_order_line.build_orders.build_order.length + 1;
        let newObj = {
          bo_line_num: build_id,
          bo_qty: buildToQty,
          bo_delete_ok: true,
          bo_edit_ok: true,
          bo_part_id: this.buildObj.part_id,
          bo_part_description: this.buildObj.part_desc,
          bo_part_number: this.buildObj.part_num,
          is_Deleted: false,
          is_Added: true,
          kit_tran_id: 0,
          build_order_ok: true,
        };
        this.temp_order_line.build_orders.build_order.push(newObj);
        this.buildOrderList.push(newObj);
        this.part_num = "";
        this.selectedbuildPart = "";
        this.buildToQty = "";
        this.partBuildPartNum = "";
        this.$refs.BuildForm?.resetValidation();
        this.disableQty = true;
        this.temp_order_line.sh_quantity = 1;
        this.temp_order_line.return_quantity = 1;
      }
    },
    // on Click open the Dialog Dialog of build order tables
    onClickEditBuild(item, buildOrderEditShow) {
      this.disableBuildSave = true;
      if (buildOrderEditShow == "buildOrderEditShow") {
        this.editListFlex = false;
        this.editWaybillShow = false;
        this.showEditBuild = true;
        this.editPartQty = item.bo_qty;
        this.showbuildDelete = item.bo_delete_ok;
        this.showbuildEdit = item.bo_edit_ok;
        this.editPartNum = item.bo_part_number;
        this.editPartDesc = item.bo_part_description;
        this.build_id = item.bo_line_num;
        this.build_Added = item.is_Added;
        this.buildRow = true;
      } else if (buildOrderEditShow == "editWaybillShow") {
        this.buildRow = false;
        this.editListFlex = false;
        this.editWaybillShow = true;
        this.showEditBuild = true;
        this.expectedDelete = item.sn_delete_ok;
        this.expectedEdit = item.sn_edit_ok;
        this.editSerialNum = item.serial_number;
        this.editAssetTag = item.asset_tag;
        this.sequence_number = item.sequence_number;
        this.editProblemDesc = item.problem_description;
        this.editWarrentyStatus = item.warranty_status;
        this.editTrack = item.return_tracking_number;
        this.editReturn_carrier = item.return_carrier;
        this.temp_waybill_id = item.temp_waybill_id;
      } else if (buildOrderEditShow == "editListFlex") {
        this.buildRow = false;
        this.editListFlex = true;
        this.editWaybillShow = false;
        this.showEditBuild = true;
        this.sequence_number = item.temp_flex_id;
        this.list_flex_field_Att = item.flex_code;
        this.list_flex_value = item.flex_data;
      }
    },
    // TO Edit the Build order Update Button
    onClickUpdateBuild(editPartQty, editPartDesc) {
      if (this.$refs.EditBuildForm?.validate()) {
        this.temp_order_line.build_orders.build_order =
          this.temp_order_line.build_orders.build_order?.map((p) =>
            p.bo_line_num == this.build_id
              ? { ...p, bo_qty: editPartQty, bo_part_description: editPartDesc }
              : p
          );
        this.buildOrderList = this.buildOrderList?.map((p) =>
          p.bo_line_num == this.build_id
            ? { ...p, bo_qty: editPartQty, bo_part_description: editPartDesc }
            : p
        );
        this.showEditBuild = false;
      }
    },
    // To delete Build order
    deleteBuild() {
      if (this.build_Added) {
        this.disableBuildSave = true;
        this.temp_order_line.build_orders.build_order =
          this.temp_order_line?.build_orders?.build_order?.filter(
            (x) => x.bo_line_num !== this.build_id
          );
      } else {
        this.temp_order_line.build_orders.build_order.find(
          (v) => v.bo_line_num === this.build_id
        ).is_Deleted = true;
      }
      this.buildOrderList = this.buildOrderList?.filter(
        (x) => x.bo_line_num !== this.build_id
      );
      this.showEditBuild = false;
      this.deleteBuildDialog = false;
      if (!this.temp_order_line.build_orders.build_order.length)
        this.disableQty = false;
    },
    // Same as Part to Recive
    async onChangeSameAsShip() {
      if (this.sameAsShip) {
        this.partReturnSearchKey = this.partShipSearchKey;
        this.returnPartNum = this.shipPartName;
        this.returnPartDesc = this.shipPartDesc;
        this.temp_order_line.return_part_number =
          this.temp_order_line.sh_part_number;
        this.temp_order_line.return_quantity = this.temp_order_line.sh_quantity;
        this.temp_order_line.return_price = this.temp_order_line.sh_price;
        this.temp_order_line.return_part_description =
          this.temp_order_line.sh_part_description;
        this.temp_order_line.return_part_id = this.temp_order_line.sh_part_id;
      } else {
        this.temp_order_line.return_part_number = "";
        //this.temp_order_line.return_quantity = ""
        this.temp_order_line.return_price = "";
        this.temp_order_line.return_part_description = "";
        this.temp_order_line.return_to_warehouse_id = "";
        this.temp_order_line.return_part_id = "";
        this.partReturnSearchKey = "";
        this.returnPartNum = "";
        this.returnPartDesc = "";
      }
      let RetrunWareObj = {
        part_num: this.temp_order_line.return_part_number,
        order_type: this.salesOrderJson.order_type,
        sotype_key: this.temp_order_line.converted_to
          ? this.temp_order_line.converted_to
          : this.temp_order_line.order_line_type,
        order_bu_key: this.salesOrderJson.bu_id,
        line_id: 0, //Do not Delete
        so_key: 0, //DO not Delete
        UserID: this.userId,
      };
      let shipWarehouseList = await salesService.postShipWareData(
        "post",
        RetrunWareObj
      );
      if (shipWarehouseList?.ReturnToWare) {
        this.returnWareList = shipWarehouseList.ReturnToWare?.map((x) => ({
          ware: x.ware,
          ware_id: x.ware_id + "_" + x.bucket,
          bucket: x.bucket,
          into_warebuck: x.into_warebuck,
        }));
      }
    },
    // return to ship
    async returnPartData() {
      this.temp_order_line.return_quantity = this.temp_order_line.sh_quantity;
      if (this.partReturnSearchKey) {
        this.clearPartReturn();
        this.partReturnSearchKey = this.partReturnSearchKey?.toUpperCase();
        if (this.partReturnSearchKey.length > 2) {
          this.showPartRetDetails = true;
          let returnSerachObj = {
            UserId: this.userId,
            SearchStr: this.partReturnSearchKey,
            BuKey: this.salesOrderJson.bu_id,
            order_type: this.salesOrderJson.order_type,
            sotype_key: this.temp_order_line.converted_to
              ? this.temp_order_line.converted_to
              : this.temp_order_line.order_line_type,
            ship_part_key: this.shipPartKey,
            line_key: 0, // Do not Delete
          };
          let returnSearchData = await salesService.postReturnSearch(
            "post",
            returnSerachObj,
            false,
            true
          );
          if (returnSearchData?.Resultset)
            this.returnResultList = returnSearchData.Resultset;
          else {
            this.clearPartReturn();
          }
        }
      }
    },
    // Return Part Desc
    async showReturnPartDesc(item) {
      this.partReturnSearchKey = item.part_num;
      this.temp_order_line.return_part_id = item.part_id;
      this.temp_order_line.return_part_number = item.part_num;
      this.temp_order_line.return_part_description = item.part_desc;
      this.temp_order_line.return_quantity = this.temp_order_line.sh_quantity;
      this.returnResultList = [];
      let RetrunWareObj = {
        part_num: item.part_num,
        order_type: this.salesOrderJson.order_type,
        sotype_key: this.temp_order_line.converted_to
          ? this.temp_order_line.converted_to
          : this.temp_order_line.order_line_type,
        order_bu_key: this.salesOrderJson.bu_id,
        line_id: 0, //Do not Delete
        so_key: 0, //DO not Delete
        UserId: this.userId,
      };
      let shipWarehouseList = await salesService.postShipWareData(
        "post",
        RetrunWareObj
      );
      this.temp_order_line.return_price = parseInt(
        shipWarehouseList.Result1[0].defaultprice
      );
      if (shipWarehouseList?.ReturnToWare) {
        this.returnWareList = shipWarehouseList.ReturnToWare?.map((x) => ({
          ware: x.ware,
          ware_id: x.ware_id + "_" + x.bucket,
          bucket: x.bucket,
          into_warebuck: x.into_warebuck,
        }));
      }
    },
    // on Save Waybill
    onClickSerialAdd(
      serialNum,
      assetTag,
      probDesc,
      selectedWarrentyStatus,
      trackNum,
      return_carrier
    ) {
      if (this.$refs.ExpectedSrForm?.validate()) {
        if (this.temp_order_line.expected_serial_number.length <= 0) {
          let expected_ord_seq =
            this.temp_order_line.expected_serial_number.length == undefined ||
            this.temp_order_line.expected_serial_number.length == null
              ? 0
              : this.temp_order_line.expected_serial_number.length;
          this.temp_waybill_id = this.temp_waybill_id + 1;
          let obj = {
            temp_waybill_id: this.temp_waybill_id,
            sequence_number: expected_ord_seq + 1,
            serial_number: serialNum,
            asset_tag: assetTag,
            problem_description: probDesc,
            warranty_status: selectedWarrentyStatus,
            return_tracking_number: trackNum,
            return_carrier: return_carrier,
            sn_edit_ok: true,
            sn_delete_ok: true,
            is_Added: true,
            is_Deleted: false,
            sobcnId: 0,
          };
          this.temp_order_line.expected_serial_number.push(obj);
          this.expected_serial_number_list.push(obj);
          this.serial_num = "";
          this.asset_tag = "";
          this.problem_desc = "";
          this.warr_status = "N";
          this.tracking_num = "";
          this.return_carrier = "";
          this.$refs.ExpectedSrForm?.resetValidation();
        } else {
          let validSerial = {};
          if (!serialNum)
            validSerial = this.temp_order_line.expected_serial_number?.find(
              (x) => x.return_tracking_number == trackNum
            );
          else {
            validSerial = this.temp_order_line.expected_serial_number?.find(
              (x) => x.serial_number == serialNum
            );
          }
          if (!trackNum)
            validSerial = this.temp_order_line.expected_serial_number?.find(
              (x) => x.serial_number == serialNum
            );
          else {
            validSerial = this.temp_order_line.expected_serial_number?.find(
              (x) => x.return_tracking_number == trackNum
            );
          }
          if (!validSerial) {
            let expected_ord_seq =
              this.temp_order_line.expected_serial_number.length == undefined ||
              this.temp_order_line.expected_serial_number.length == null
                ? 0
                : this.temp_order_line.expected_serial_number.length;
            this.temp_waybill_id = this.temp_waybill_id + 1;
            let obj = {
              temp_waybill_id: this.temp_waybill_id,
              sequence_number: expected_ord_seq + 1,
              serial_number: serialNum,
              asset_tag: assetTag,
              problem_description: probDesc,
              warranty_status: selectedWarrentyStatus,
              return_tracking_number: trackNum,
              return_carrier: return_carrier,
              sn_edit_ok: true,
              sn_delete_ok: true,
              is_Added: true,
              is_Deleted: false,
              sobcnId: 0,
            };
            this.temp_order_line.expected_serial_number.push(obj);
            this.expected_serial_number_list.push(obj);
            this.serial_num = "";
            this.asset_tag = "";
            this.problem_desc = "";
            this.warr_status = "N";
            this.tracking_num = "";
            this.return_carrier = "";
            this.$refs.ExpectedSrForm?.resetValidation();
          } else {
            if (validSerial?.serial_number) {
              let Alert = {
                type: "error",
                isShow: true,
                message:
                  "The Serial number " +
                  serialNum +
                  " is already added in the order line",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            } else {
              let Alert = {
                type: "error",
                isShow: true,
                message:
                  "The Tracking number " +
                  trackNum +
                  " is already added in the order line",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          }
        }
      }
    },
    // Update waybil
    onClickUpdateWaybill(
      editSerialNum,
      editAssetTag,
      editProblemDesc,
      editWarrentyStatus,
      editTrack,
      return_carrier
    ) {
      if (this.$refs.EditExpectedSrForm?.validate()) {
        this.expectedUpdate = false;
        this.temp_order_line.expected_serial_number =
          this.temp_order_line.expected_serial_number?.map((p) =>
            p.temp_waybill_id == this.temp_waybill_id
              ? {
                  ...p,
                  serial_number: editSerialNum,
                  asset_tag: editAssetTag,
                  problem_description: editProblemDesc,
                  warranty_status: editWarrentyStatus,
                  return_tracking_number: editTrack,
                  return_carrier: return_carrier,
                }
              : p
          );
        this.expected_serial_number_list =
          this.expected_serial_number_list?.map((p) =>
            p.temp_waybill_id == this.temp_waybill_id
              ? {
                  ...p,
                  serial_number: editSerialNum,
                  asset_tag: editAssetTag,
                  problem_description: editProblemDesc,
                  warranty_status: editWarrentyStatus,
                  return_tracking_number: editTrack,
                  return_carrier: return_carrier,
                }
              : p
          );
        this.showEditBuild = false;
        this.$refs.EditExpectedSrForm?.resetValidation();
        this.$refs.EditExpectedSrForm?.reset();
      }
    },
    // Delete Waybill
    deleteWaybill() {
      if (this.temp_order_line.expected_serial_number.is_Added) {
        this.temp_order_line.expected_serial_number =
          this.temp_order_line?.expected_serial_number?.filter(
            (x) => x.temp_waybill_id !== this.temp_waybill_id
          );
      } else {
        this.expected_serial_number_list =
          this.expected_serial_number_list?.filter(
            (x) => x.temp_waybill_id !== this.temp_waybill_id
          );
        this.temp_order_line.expected_serial_number.find(
          (v) => v.temp_waybill_id === this.temp_waybill_id
        ).is_Deleted = true;
      }
      this.showEditBuild = false;
      this.deleteBuildDialog = false;
      this.$refs.EditExpectedSrForm?.resetValidation();
      this.$refs.EditExpectedSrForm?.reset();
    },
    // Edit Line List
    //View Line Item Details
    async lineItemsView(item) {
      if (item.order_line_type == 1) {
        this.lineItemPanel = [0];
      } else if (item.order_line_type == 8) {
        this.lineItemPanel = [1];
      } else {
        this.lineItemPanel = [0, 1];
      }
      this.enableEdit = true;
      this.showConevertDropDown = false;
      this.shipWareList = [];
      this.returnWareList = [];
      this.shipPartKey = item.sh_part_id;
      if (item.is_Added || item.isEdited) {
        this.temp_order_line = JSON.parse(
          JSON.stringify(
            this.salesOrderJson?.order_line?.filter(
              (x) => x.line_number == item.line_number
            )[0]
          )
        );
        if (
          item.isEdited &&
          !this.temp_order_line.is_Converted &&
          !this.temp_order_line.is_FAllocated
        ) {
          this.temp_order_line["showConvertBtn"] = true;
          this.temp_order_line["showForceBtn"] = true;
        } else {
          this.temp_order_line["showConvertBtn"] = false;
          this.temp_order_line["showForceBtn"] = false;
        }
      } else {
        let lineItemData = await salesOrderEditService.getLineItemData(
          "get",
          this.userId,
          item.line_id
        );
        this.temp_order_line = JSON.parse(
          JSON.stringify(lineItemData.LineItem[0])
        );
        this.temp_order_line["showConvertBtn"] = true;
        this.temp_order_line["showForceBtn"] = this.temp_order_line.enable_fallocate;
      }
      this.temp_order_line.expected_serial_number.forEach(
        (item, index) => (item.temp_waybill_id = index + 1)
      );
      this.expected_serial_number_list = JSON.parse(
        JSON.stringify(this.temp_order_line.expected_serial_number)
      )?.filter((x) => x.is_Deleted == false);
      this.buildOrderList = JSON.parse(
        JSON.stringify(this.temp_order_line.build_orders.build_order)
      )?.filter((x) => x.is_Deleted == false);
      if (this.buildOrderList.length > 0) {
        this.disableQty = true;
      }
      this.showPartDetails = true;
      this.showPartsItem = true;
      this.showLineDelete = true;
      this.showLineFlagDelete = this.temp_order_line.enable_delete;
      if (this.temp_order_line.is_Converted) {
        this.showConevertDropDown = true;
      }
      this.LineTypeData(item, !item.line_id);
      this.warrentyData();
      this.showPartsItem = true;
      this.disableLine = true;
      this.disablePartShip = !this.temp_order_line.enable_inbound_save;
    },
    async onChangeShipping() {
      this.salesOrderJson.signature_required = false;
      this.salesOrderJson.saturday_delivery = false;
      let CarrierFlags = this.outboundList?.filter(
        (x) => x.sl_id == this.salesOrderJson.shipping_priority
      );
      this.disableSignature = CarrierFlags[0].sig_required;
      this.disableSatDel = CarrierFlags[0].sat_delivery;
      this.disable3rdPartyOutbound = true;
      const showLocationOutbound = Boolean(CarrierFlags[0].show_3rdparty_location);
      if (showLocationOutbound) await this.loadCountryList();
      this.show3rdPartyOutbound = Boolean(CarrierFlags[0].show_3rdparty);
      this.show3rdPartyLocationOutbound = showLocationOutbound;
      this.salesOrderJson.account_3rd_party = this.show3rdPartyOutbound ? (CarrierFlags[0].account_3rd_party || "") : "";
      this.salesOrderJson.zip_3rd_party = (this.show3rdPartyOutbound && this.show3rdPartyLocationOutbound) ? (CarrierFlags[0].zip_3rdparty || "") : "";
      this.salesOrderJson.countrycode_3rd_party = (this.show3rdPartyOutbound && this.show3rdPartyLocationOutbound) ? (CarrierFlags[0].country_3rdparty || "") : "";
    },
    async onChangeInboundShipping() {
      let CarrierFlags = this.inboundList?.filter(
        (x) => x.sl_id == this.salesOrderJson.return_shipping_priority
      );
      if (!CarrierFlags?.length) return;
      this.disable3rdPartyInbound = true;
      const showLocationInbound = Boolean(CarrierFlags[0].show_3rdparty_location);
      if (showLocationInbound) await this.loadCountryList();
      this.show3rdPartyInbound = Boolean(CarrierFlags[0].show_3rdparty);
      this.show3rdPartyLocationInbound = showLocationInbound;
      this.salesOrderJson.account_3rd_party_rtn = this.show3rdPartyInbound ? (CarrierFlags[0].account_3rd_party || "") : "";
      this.salesOrderJson.zip_3rd_party_rtn = (this.show3rdPartyInbound && this.show3rdPartyLocationInbound) ? (CarrierFlags[0].zip_3rdparty || "") : "";
      this.salesOrderJson.countrycode_3rd_party_rtn = (this.show3rdPartyInbound && this.show3rdPartyLocationInbound) ? (CarrierFlags[0].country_3rdparty || "") : "";
    },
    async loadCountryList() {
      if (this.countryList.length > 0) return;
      let data = await commonApiService.countryListNew(this.userId, "", 1, "get");
      this.countryList = data.CountryInfo;
    },
    //onClick Delete
    onClickLineDelete() {
      if (this.isShippingHold) return;
      this.deleteBuildDialog = true;
      this.deleteItem = true;
    },
    onChangeConvert() {
      if (this.isShippingHold) return;
      this.showForceDialog = true;
      this.convertMsg = true;
    },
    // on Convert line ITem
    onConvertLine() {
      if (this.isShippingHold) return;
      this.lineItemPanel = [0, 1];
      this.showForceDialog = false;
      this.convertMsg = false;
      let convertData = this.lineTypeList?.filter(
        (x) => x.so_type_id == this.temp_order_line.converted_to
      );
      this.showPartShip = Boolean(convertData[0].to_ship);
      this.showPartRet = Boolean(convertData[0].to_return);
      this.disableRetQty = Boolean(convertData[0].to_disable_quantity);
      if (this.showPartShip && this.showPartRet) {
        this.lineItemPanel = [0, 1];
      } else if (!this.showPartShip) {
        this.clearPartShip();
        this.showPartShip = false;
        this.lineItemPanel = [0, 1];
      } else if (!this.showPartRet) {
        this.clearPartReturn();
        this.showPartRet = false;
        this.lineItemPanel = [0, 1];
      }
    },
    //Delete Line Item
    deleteLineItem() {
      if (this.isShippingHold) return;
      this.temp_order_line.return_to_warehouse_id =
        this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
      this.temp_order_line.sh_from_warehouse_id =
        this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
      if (this.temp_order_line.is_Added) {
        this.salesOrderJson.order_line =
          this.salesOrderJson?.order_line?.filter(
            (x) => x.line_number !== this.edit_line_num
          );
      } else if (
        !this.temp_order_line.is_Added &&
        !this.temp_order_line.is_Deleted
      ) {
        this.salesOrderJson.order_line =
          this.salesOrderJson?.order_line?.filter(
            (x) => x.line_number !== this.edit_line_num
          );
        this.temp_order_line.is_Deleted = true;
        this.temp_order_line.is_Edited = true;
        this.salesOrderJson.order_line.push(this.temp_order_line);
      } else {
        this.temp_order_line.is_Deleted = true;
        this.temp_order_line.is_Edited = true;
        this.salesOrderJson.order_line.push(this.temp_order_line);
      }
      this.salesOrderJson.order_list = this.salesOrderJson?.order_list?.filter(
        (x) => x.line_number !== this.edit_line_num
      );
      this.deleteBuildDialog = false;
      this.showPartsItem = false;
      this.totalRecords = this.salesOrderJson.order_line.length;
    },
    // Edit Line ITem
    editLineItem() {
      if (this.isShippingHold) return;
      this.temp_order_line.showPartShip = this.showPartShip;
      this.temp_order_line.showPartRet = this.showPartRet;
      let temp_objIdx = this.salesOrderJson.order_list?.findIndex(
        (v) => v.line_number === this.temp_order_line.line_number
      );
      if (!~temp_objIdx) {
        return;
      }
      let temp_obj = this.salesOrderJson.order_list[temp_objIdx];
      if (this.temp_order_line.converted_to) {
        this.temp_order_line.is_Converted = true;
        this.salesOrderJson.order_line =
          this.salesOrderJson?.order_line?.filter(
            (x) => x.line_number !== this.edit_line_num
          );
        let convertData = this.lineTypeList?.filter(
          (x) => x.so_type_id == this.temp_order_line.converted_to
        );
        temp_obj.order_line_text = convertData[0]?.so_desc;
        temp_obj.order_line_type = convertData[0]?.so_type_id;
      }
      if (this.temp_order_line.is_Added) {
        this.salesOrderJson.order_line =
          this.salesOrderJson?.order_line?.filter(
            (x) => x.line_number !== this.edit_line_num
          );
        this.temp_order_line.is_Edited = false;
        this.temp_order_line.is_Deleted = false;
        this.temp_order_line.return_to_warehouse_id =
          this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
        this.temp_order_line.sh_from_warehouse_id =
          this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
        temp_obj.return_to_warehouse = this.temp_order_line.return_to_warehouse;
        temp_obj.return_to_inventory_bucket =
          this.temp_order_line.return_to_inventory_bucket;
        temp_obj.sh_from_warehouse = this.temp_order_line.sh_from_warehouse;
        temp_obj.sh_from_inventory_bucket =
          this.temp_order_line.sh_from_inventory_bucket;
        temp_obj.expected_serial_number = JSON.parse(
          JSON.stringify(this.temp_order_line?.expected_serial_number)
        );
        this.salesOrderJson.order_line.push(temp_obj);
      } else {
        this.temp_order_line.is_Deleted = false;
        this.temp_order_line.is_Added = false;
        this.temp_order_line.is_Edited = true;
        if (this.temp_order_line?.return_to_warehouse_id?.includes("_")) {
          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line.return_to_warehouse_id.split("_")[0];
        }
        if (this.temp_order_line?.sh_from_warehouse_id?.includes("_")) {
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line.sh_from_warehouse_id.split("_")[0];
        }
        this.salesOrderJson.order_line =
          this.salesOrderJson?.order_line?.filter(
            (x) => x.line_number !== this.edit_line_num
          );
        this.salesOrderJson.order_line.push(this.temp_order_line);
      }
      if (this.showPartShip && this.showPartRet) {
        if (
          this.$refs.PartShipForm?.validate() &&
          this.$refs.PartRecieveForm?.validate()
        ) {
          temp_obj.sh_part_number = this.temp_order_line.sh_part_number;
          temp_obj.sh_part_description =
            this.temp_order_line.sh_part_description;

          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
          temp_obj.quantity =
            this.temp_order_line.sh_quantity != ""
              ? parseInt(this.temp_order_line.sh_quantity)
              : parseInt(this.temp_order_line.return_quantity);
          temp_obj.Open_Shipments = temp_obj.quantity - temp_obj.Shipped;
          temp_obj.Open_Receipts = temp_obj.quantity - temp_obj.Rcvd;
          temp_obj.isEdited = true;
          if (this.temp_order_line.converted_to) {
            let convertData = this.lineTypeList?.filter(
              (x) => x.so_type_id == this.temp_order_line.converted_to
            );
            temp_obj.order_line_text = convertData[0]?.so_desc;
          }
          temp_obj.return_part_number = this.temp_order_line.return_part_number;
          temp_obj.return_part_description =
            this.temp_order_line.return_part_description;
          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
          this.showPartsItem = false;
          temp_obj.return_to_warehouse =
            this.temp_order_line.return_to_warehouse;
          temp_obj.return_to_inventory_bucket =
            this.temp_order_line.return_to_inventory_bucket;
          temp_obj.sh_from_warehouse = this.temp_order_line.sh_from_warehouse;
          temp_obj.sh_from_inventory_bucket =
            this.temp_order_line.sh_from_inventory_bucket;
          this.salesOrderJson.order_list.splice(temp_objIdx, 1, temp_obj);
        }
      } else if (this.showPartShip && !this.showPartRet) {
        if (this.$refs.PartShipForm?.validate()) {
          temp_obj.sh_part_number = this.temp_order_line.sh_part_number;
          temp_obj.sh_part_description =
            this.temp_order_line.sh_part_description;
          temp_obj.quantity =
            this.temp_order_line.sh_quantity != ""
              ? parseInt(this.temp_order_line.sh_quantity)
              : parseInt(this.temp_order_line.return_quantity);
          temp_obj.Open_Shipments = temp_obj.quantity - temp_obj.Shipped;
          temp_obj.return_part_number = "";
          temp_obj.return_part_description = "";
          temp_obj.Open_Receipts = 0;
          temp_obj.isEdited = true;
          if (this.temp_order_line.converted_to) {
            let convertData = this.lineTypeList?.filter(
              (x) => x.so_type_id == this.temp_order_line.converted_to
            );
            temp_obj.order_line_text = convertData[0]?.so_desc;
          }
          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
          temp_obj.return_to_warehouse =
            this.temp_order_line.return_to_warehouse;
          temp_obj.return_to_inventory_bucket =
            this.temp_order_line.return_to_inventory_bucket;
          temp_obj.sh_from_warehouse = this.temp_order_line.sh_from_warehouse;
          temp_obj.sh_from_inventory_bucket =
            this.temp_order_line.sh_from_inventory_bucket;
          this.showPartsItem = false;
          this.salesOrderJson.order_list.splice(temp_objIdx, 1, temp_obj);
        }
      } else if (!this.showPartShip && this.showPartRet) {
        if (this.$refs.PartRecieveForm?.validate()) {
          temp_obj.return_part_number = this.temp_order_line.return_part_number;
          temp_obj.return_part_description =
            this.temp_order_line.return_part_description;
          temp_obj.quantity =
            this.temp_order_line.sh_quantity != ""
              ? parseInt(this.temp_order_line.sh_quantity)
              : parseInt(this.temp_order_line.return_quantity);
          temp_obj.Open_Receipts = temp_obj.quantity - temp_obj.Rcvd;
          temp_obj.sh_part_number = "";
          temp_obj.sh_part_description = "";
          temp_obj.Open_Shipments = 0;
          temp_obj.isEdited = true;
          temp_obj.quantity =
            this.temp_order_line.sh_quantity != ""
              ? parseInt(this.temp_order_line.sh_quantity)
              : parseInt(this.temp_order_line.return_quantity);
          if (this.temp_order_line.converted_to) {
            let convertData = this.lineTypeList?.filter(
              (x) => x.so_type_id == this.temp_order_line.converted_to
            );
            temp_obj.order_line_text = convertData[0]?.so_desc;
          }
          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
          this.showPartsItem = false;
          temp_obj.return_to_warehouse =
            this.temp_order_line.return_to_warehouse;
          temp_obj.return_to_inventory_bucket =
            this.temp_order_line.return_to_inventory_bucket;
          temp_obj.sh_from_warehouse = this.temp_order_line.sh_from_warehouse;
          temp_obj.sh_from_inventory_bucket =
            this.temp_order_line.sh_from_inventory_bucket;
          this.salesOrderJson.order_list.splice(temp_objIdx, 1, temp_obj);
        }
      }
    },
    //Cancel Line Item
    cancelLineItems() {
      this.clearPartItem();
      this.showPartsItem = false;
      this.editLinePart = true;
    },
    // On Click Add Part List Item
    submitLineItems() {
      if (this.isShippingHold) return;
      this.temp_order_line.Allocated = 0;
      this.temp_order_line.Picked = 0;
      this.temp_order_line.Shipped = 0;
      this.temp_order_line.Rcvd = 0;
      this.buildOrderList.length > 0
        ? (this.temp_order_line.build_order_ok = true)
        : (this.temp_order_line.build_order_ok = false);
      this.temp_order_line.enable_save = true;
      let order_line_num =
        this.salesOrderJson.order_list.length == null ||
        this.salesOrderJson.order_list.length == undefined
          ? 0
          : this.salesOrderJson.order_list.length;
      this.temp_order_line.is_FAllocated = false;

      if (this.showPartShip && this.showPartRet) {
        if (
          this.$refs.PartShipForm?.validate() &&
          this.$refs.PartRecieveForm?.validate()
        ) {
          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
          this.temp_order_line.line_number = order_line_num + 1;
          this.temp_order_line.sequence_number =
            this.temp_order_line.line_number;
          this.temp_order_line.is_Added = true;
          this.temp_order_line.is_Edited = false;
          this.temp_order_line.is_Deleted = false;
          this.temp_order_line.quantity = this.temp_order_line.sh_quantity;
          this.temp_order_line.Open_Shipments =
            this.temp_order_line.quantity - this.temp_order_line.Shipped;
          this.temp_order_line.Open_Receipts =
            this.temp_order_line.quantity - this.temp_order_line.Rcvd;
          this.salesOrderJson.order_list.push(this.temp_order_line);
          this.salesOrderJson.order_line.push(this.temp_order_line);

          this.showPartsItem = false;
        }
      } else if (this.showPartShip && !this.showPartRet) {
        if (this.$refs.PartShipForm?.validate()) {
          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
          this.temp_order_line.line_number = order_line_num + 1;
          this.temp_order_line.sequence_number =
            this.temp_order_line.line_number;
          this.temp_order_line.is_Added = true;
          this.temp_order_line.is_Edited = false;
          this.temp_order_line.is_Deleted = false;
          this.temp_order_line.quantity = this.temp_order_line.sh_quantity;
          this.temp_order_line.Open_Receipts = 0;
          this.temp_order_line.Open_Shipments =
            this.temp_order_line.quantity - this.temp_order_line.Shipped;
          this.salesOrderJson.order_list.push(this.temp_order_line);
          this.salesOrderJson.order_line.push(this.temp_order_line);
          this.showPartsItem = false;
        }
      } else if (!this.showPartShip && this.showPartRet) {
        if (this.$refs.PartRecieveForm?.validate()) {
          this.temp_order_line.return_to_warehouse_id =
            this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
          this.temp_order_line.sh_from_warehouse_id =
            this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
          this.temp_order_line.line_number = order_line_num + 1;
          this.temp_order_line.sequence_number =
            this.temp_order_line.line_number;
          this.temp_order_line.is_Edited = false;
          this.temp_order_line.is_Deleted = false;
          this.temp_order_line.quantity = this.temp_order_line.return_quantity;
          this.temp_order_line.Open_Shipments = 0;
          this.temp_order_line.Open_Receipts =
            this.temp_order_line.quantity - this.temp_order_line.Rcvd;
          this.temp_order_line.is_Added = true;
          this.salesOrderJson.order_list.push(this.temp_order_line);
          this.salesOrderJson.order_line.push(this.temp_order_line);
          this.showPartsItem = false;
        }
      }
      this.totalRecords = this.salesOrderJson.order_list.length;
      this.validateLineType();
    },
    checkPriceBeforeSubmit() {
      if (this.isShippingHold) return;
      const price = parseFloat(this.temp_order_line.sh_price) || 0;
      if (this.showPartShip && (this.fix_price > 0 || this.avg_cost > 0) && (price < this.fix_price || price < this.avg_cost)) {
        this.isSubmitAction = true;
        this.linePriceWarningDialog = true;
      } else {
        this.submitLineItems();
      }
    },
    checkPriceBeforeEdit() {
      if (this.isShippingHold) return;
      const price = parseFloat(this.temp_order_line.sh_price) || 0;
      if (this.showPartShip && (this.fix_price > 0 || this.avg_cost > 0) && (price < this.fix_price || price < this.avg_cost)) {
        this.isSubmitAction = false;
        this.linePriceWarningDialog = true;
      } else {
        this.editLineItem();
      }
    },
    onPriceWarningYesSubmit() {
      if (this.isShippingHold) return;
      this.linePriceWarningDialog = false;
      this.submitLineItems();
    },
    onPriceWarningYesEdit() {
      if (this.isShippingHold) return;
      this.linePriceWarningDialog = false;
      this.editLineItem();
    },
    // on Change LIne Typeh
    onChangeLineType(value) {
      this.disablePartShip = false;
      this.temp_order_line.enable_save = true;
      if (value.order_line_type == 1) {
        this.lineItemPanel = [0];
      } else if (value.order_line_type == 8) {
        this.lineItemPanel = [1];
      } else {
        this.lineItemPanel = [0, 1];
      }
      this.enableEdit = false;
      this.disableLine = true;
      let obj = this.lineTypeList?.filter((x) => x.so_type_id == value);
      this.showPartShip = obj[0]?.to_ship == 1 ? true : false;
      this.showPartRet = obj[0]?.to_return == 1 ? true : false;
      this.showFlex = true;
      this.temp_order_line.order_line_text = obj[0]?.so_desc;
      this.temp_order_line.showPartShip = this.showPartShip;
      this.temp_order_line.showPartRet = this.showPartRet;
      this.disableRetQty = obj[0]?.to_disable_quantity == 1 ? true : false;
      this.disablePartRecieve = obj[0].to_disable_ReturnSel == 1 ? true : false;
      if (this.disablePartRecieve) {
        this.partReturnSearchKey = this.partShipSearchKey;
        this.temp_order_line.return_part_number =
          this.temp_order_line.sh_part_number;
        this.temp_order_line.return_quantity = this.temp_order_line.sh_quantity;
        this.temp_order_line.return_part_description =
          this.temp_order_line.sh_part_description;
        this.temp_order_line.return_part_id = this.temp_order_line.sh_part_id;
      }
      if (value == 2 || value == 6) {
        this.temp_order_line.sh_quantity = 1;
      }
      // if part return is true then only return rma gets filled otherwise its empty
      if (this.showPartRet)
        this.temp_order_line.return_rma = this.salesOrderJson.rma;
      else this.temp_order_line.return_rma = "";
    },
    // On Chnage Part SHip WareHouse DropDOwn
    onPartShipChange(warehouse_id) {
      let partShipObj = this.shipWareList?.filter(
        (x) => x.ware_id == warehouse_id
      );
      this.temp_order_line.sh_from_inventory_bucket = partShipObj[0]?.bucket;
      this.temp_order_line.sh_from_warehouse = partShipObj[0]?.ware;
      this.temp_order_line.sh_from_warehouse_id = partShipObj[0]?.ware_id;
      this.showStockStatus = partShipObj[0].mess_bit;
      this.stockMessage = partShipObj[0].show_text;
      this.fix_price = partShipObj[0].fix_price || 0;
      this.last_price = partShipObj[0].last_price || 0;
      this.avg_cost = partShipObj[0].avg_cost || 0;
      this.showPriceInfo = true;
    },
    //Reset Data to API Call JSON
    resetFunction() {
      this.salesOrderJson = JSON.parse(
        JSON.stringify(this.salesOrderDetails.Result[0])
      );
      this.mapSalesOrderResultFields();
      this.convertTime();

      this.showOrderedDate = false;
      this.showShipByDate = false;
      this.showEndDate = false;
      this.showNewHireDate = false;
      this.$nextTick(() => {
        this.showOrderedDate = true;
        this.showShipByDate = true;
        this.showNewHireDate = true;
      });
    },
    //Add BookMark
    async addBookmark() {
      let resp = await salesOrderEditService.addBookMark(
        "get",
        this.userId,
        this.salesOrderId,
        true
      );
      if (resp?.Result) {
        this.bookmark = true;
        this.showActionsList = this.showActionsList?.filter(
          (item) => item.Id != "SO-BookMark"
        );
        this.showActionsList.unshift({
          Id: "SO-BookMark-Remove",
          Icon: "mdi mdi-bookmark-outline",
          FriendlyName: "Remove Bookmark",
        });
      } else this.bookmark = false;
      bus.$emit("bookmark", this.bookmark);
    },
    //remove BookMark
    async removeBookmark() {
      let resp = await salesService.getDeleteBookmarkSO(
        "get",
        this.userId,
        this.salesOrderId,
        true
      );
      if (resp?.Result) {
        this.bookmark = false;
        this.showActionsList = this.showActionsList?.filter(
          (item) => item.Id != "SO-BookMark-Remove"
        );
        this.showActionsList.unshift({
          Id: "SO-BookMark",
          Icon: "mdi mdi-bookmark",
          FriendlyName: "Add Bookmark",
        });
      } else this.bookmark = true;
      bus.$emit("bookmark", this.bookmark);
    },
    // Update API
    async postSoUpdate() {
      if (this.$refs.salesOrderForm?.validate()) {
        const carrierFormValid = this.validateOptionalForm("CarrierLevlInfoForm");
        const addressFormValid = this.validateOptionalForm("addressForm");
        if (carrierFormValid && addressFormValid) {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.final_submit = true;
          this.clearCustAddressData();
          let timeZoneTime = Utility.getTimeFromLocalToTimeZone();

          if (this.salesOrderJson.new_hire_date) {
            this.salesOrderJson.new_hire_date = Utility.inputDateFormat(
              this.newHireComputedDateFormattedMomentjs,
              timeZoneTime,
              true
            );
          }
          if (this.salesOrderJson.requested_ship_date) {
            this.salesOrderJson.requested_ship_date = Utility.inputDateFormat(
              this.shipcomputeDateFormattedMomentjs,
              timeZoneTime,
              true
            );
          }

          this.salesOrderJson.comments_fields = this.commentList;
          this.salesOrderJson.calllogs_field = this.callLogsData;
          const salesOrderSaveJson = this.buildSalesOrderSaveJson();
          let final_save = {
            UserId: this.userId,
            json: JSON.stringify(salesOrderSaveJson),
          };
          let saveOrder = await salesOrderEditService.postSoUpdate(
            "post",
            final_save,
            true
          );

          if (saveOrder!=400) {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            if( this.salesOrderJson?.new_hire_date){
            this.salesOrderJson.new_hire_date = Utility.inputDateFormat(
              this.newHireComputedDateFormattedMomentjs,
              timeZoneTime,
              false
            );}
            if(this.salesOrderJson?.requested_ship_date){
            this.salesOrderJson.requested_ship_date = Utility.inputDateFormat(
              this.shipcomputeDateFormattedMomentjs,
              timeZoneTime,
              false
            );
          }
            this.$router.push({
              name: "salesOrderDetails",
              params: {
                id: btoa(this.salesOrderId),
              },
              query: this.salesOrderDetailsReturnQuery(),
            });
          }
        } else {
          if (!addressFormValid && !carrierFormValid) {
            this.scrollToInvalidFormField("addressForm");
            if (this.returnReq) this.disableReturn = false;
            else this.disableShip2 = false;
            this.disableShippingSection = false;
          } else if (!addressFormValid) {
            this.scrollToInvalidFormField("addressForm");
            if (this.returnReq) this.disableReturn = false;
            else this.disableShip2 = false;
          } else {
            this.disableShippingSection = false;
            this.scrollToInvalidFormField("CarrierLevlInfoForm");
          }
        }
      } else {
        this.scrollToInvalidFormField("salesOrderForm");
      }
    },
    // Delete SO
    deleteClicked() {
      this.deleteBuildDialog = true;
      this.soDelete = true;
    },
    //Delete API Call
    async deleteSOClicked() {
      let deleteObj = {
        so_id: this.salesOrderId,
        current_status: "X",
        cancel_reason: this.cancelReason,
        userId: this.userId,
      };
      let delRes = await salesOrderEditService.postSoCancel(
        "post",
        deleteObj,
        true
      );
      if (delRes?.Result) {
        this.deleteReasonDialog = false;
        this.final_submit = true;
        this.isEditing = false;
        this.deleteBuildDialog = false;
        this.$router.push(`/sales-order`);
      }
    },
    onClickHoldDialogBtn() {
      if (this.isShippingHold) return;
      this.$refs.holdReasonForm?.resetValidation();
      this.holdReason = "";
      this.holdReasonDialog = true;
    },
    onClickShipmentHoldConfirm() {
      this.shipmentHoldConfirmDialog = true;
    },
    onClickShipmentHoldReasonDialog() {
      this.$refs.shipmentHoldReasonForm?.resetValidation();
      this.shipmentHoldReason = "";
      this.shipmentHoldConfirmDialog = false;
      this.shipmentHoldReasonDialog = true;
    },
    async submitShipmentHoldRelease() {
      this.shipmentHoldConfirmDialog = false;
      this.shipmentHoldReasonDialog = false;
      let shipmentHoldObj = {
        so_id: this.salesOrderId,
        hold_reason: "",
        UserId: this.userId,
      };
      let resp = await salesOrderEditService.postSoShippingHold(
        "post",
        shipmentHoldObj,
        true
      );

      if (resp?.Result) {
        this.salesOrderJson.message = resp.Result[0].displaymessage;
        this.getCommentsData();
        this.salesOrderDetails =
          await salesOrderEditService.getSalesOrderDetails(
            "get",
            this.userId,
            this.salesOrderId
          );
        this.salesOrderJson = JSON.parse(
          JSON.stringify(this.salesOrderDetails.Result[0])
        );
        this.mapSalesOrderResultFields();
        this.final_submit = true;
        this.isEditing = false;
        this.$router.push(`/sales-order-details/${btoa(this.salesOrderId)}`);
      }
    },
    async submitShipmentHoldReason() {
      if (!this.$refs.shipmentHoldReasonForm?.validate()) return;

      this.shipmentHoldConfirmDialog = false;
      this.shipmentHoldReasonDialog = false;
      let shipmentHoldObj = {
        so_id: this.salesOrderId,
        hold_reason: this.shipmentHoldReason,
        UserId: this.userId,
      };
      let resp = await salesOrderEditService.postSoShippingHold(
        "post",
        shipmentHoldObj,
        true
      );

      if (resp?.Result) {
        this.salesOrderJson.message = resp.Result[0].displaymessage;
        this.getCommentsData();
        this.salesOrderDetails =
          await salesOrderEditService.getSalesOrderDetails(
            "get",
            this.userId,
            this.salesOrderId
          );
        this.salesOrderJson = JSON.parse(
          JSON.stringify(this.salesOrderDetails.Result[0])
        );
        this.mapSalesOrderResultFields();
        this.final_submit = true;
        this.isEditing = false;
        this.$router.push(`/sales-order-details/${btoa(this.salesOrderId)}`);
      }
    },
    //Hold SO
    async postSoHold() {
      if (this.isShippingHold) return;
      this.disableHoldBtn = true;
      this.showForceDialog = false;
      this.holdReasonDialog = false;
      let deleteObj = {
        so_id: this.salesOrderId,
        current_status: "H",
        cancel_reason: this.holdReason,
        userId: this.userId,
      };
      let resp = await salesOrderEditService.postSoDelete(
        "post",
        deleteObj,
        true
      );
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

      if (resp?.Result) {
        this.salesOrderJson.message = resp.Result[0].displaymessage;
        this.holdMsg = false;
        this.hold = true;
        this.disableHoldBtn = false;
        this.getCommentsData();
        this.showActionsList = this.showActionsList?.filter(
          (item) => item.Id != "SO-Hold"
        );
        this.showActionsList.unshift({
          Id: "SO-Hold",
          Icon: "mdi mdi-play-outline",
          FriendlyName: "SO Release",
        });
        this.salesOrderDetails =
          await salesOrderEditService.getSalesOrderDetails(
            "get",
            this.userId,
            this.salesOrderId
          );
        // Assigning the values we get from API to the Form JSON we created
        this.salesOrderJson = JSON.parse(
          JSON.stringify(this.salesOrderDetails.Result[0])
        );
        this.mapSalesOrderResultFields();
        LoaderDialog.visible = false;
        this.final_submit = true;
        this.isEditing = false;
        this.$router.push(`/sales-order-details/${btoa(this.salesOrderId)}`);
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      } else this.hold = false;
      bus.$emit("hold", this.hold);
      this.releaseMsg = false;
    },
    //Release Hold
    async postSoHoldRelease() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.disableHoldBtn = true;
      this.showForceDialog = false;
      let deleteObj = {
        so_id: this.salesOrderId,
        current_status: "",
        cancel_reason: "",
        userId: this.userId,
      };
      let resp = await salesOrderEditService.postSoDelete(
        "post",
        deleteObj,
        true
      );
      if (resp?.Result) {
        this.hold = false;
        this.getCommentsData();
        this.releaseMsg = false;
        this.disableHoldBtn = false;
        this.showActionsList = this.showActionsList?.filter(
          (item) => item.Id != "SO-Release"
        );
        if (!this.isShippingHold) {
          this.showActionsList.unshift({
            Id: "SO-Hold",
            Icon: "mdi mdi-pause-box-outline",
            FriendlyName: "SO Hold",
          });
        }
        this.salesOrderDetails =
          await salesOrderEditService.getSalesOrderDetails(
            "get",
            this.userId,
            this.salesOrderId
          );
        // Assigning the values we get from API to the Form JSON we created
        this.salesOrderJson = JSON.parse(
          JSON.stringify(this.salesOrderDetails.Result[0])
        );
        this.mapSalesOrderResultFields();
        LoaderDialog.visible = false;
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      } else this.hold = true;
      bus.$emit("hold", this.hold);
      this.holdMsg = false;
    },
    //Force Allocate
    OnClickForce() {
      if (this.isShippingHold) return;
      this.showForceDialog = false;
      this.temp_order_line.is_FAllocated = true;
      this.temp_order_line.is_Edited = true;
      this.temp_order_line.showForceBtn = false;
      this.temp_order_line.showConvertBtn = false;
      this.temp_order_line.return_to_warehouse_id =
        this.temp_order_line?.return_to_warehouse_id?.split("_")[0];
      this.temp_order_line.sh_from_warehouse_id =
        this.temp_order_line?.sh_from_warehouse_id?.split("_")[0];
      this.showPartsItem = false;
      this.forceMsg = false;
      this.salesOrderJson.order_list.find(
        (v) => v.line_number === this.temp_order_line.line_number
      ).isEdited = true;
      this.salesOrderJson.order_line.push(this.temp_order_line);
    },
    // Reset Line Data
    resetLineData() {
      if (this.showLineDelete)
        this.temp_order_line = JSON.parse(
          JSON.stringify(this.tempOrderLineBackup)
        );
      else this.clearPartItem();
    },
    // onClick Picked
    async onClickedHyperLink(value, item) {
      if (value === "Picked") {
        let pickedData = await salesOrderEditService.getSalesOrderPickedData(
          "get",
          this.salesOrderId,
          item.line_number,
          this.userId
        );
        if (pickedData?.Data) {
          this.showLinkDialog = true;
          this.selectedLink = value;
          this.pickedDataList = pickedData.Data;
          this.pickedDataList.forEach((element) => {
            element.Picked = Utility.displayDateFormat(element.Picked);
          });
        }
      } else if (value === "Received") {
        let receivedData =
          await salesOrderEditService.getSalesOrderReceivedData(
            "get",
            this.salesOrderId,
            item.line_number,
            this.userId
          );
        if (receivedData?.Data) {
          this.showLinkDialog = true;
          this.selectedLink = value;
          this.receivedDataList = receivedData.Data;
          this.receivedDataList?.forEach((element) => {
            element.Date = Utility.displayDateFormat(element.Date);
          });
        }
      } else if (value === "Shipped") {
        let shippedData = await salesOrderEditService.getSalesOrderShippedData(
          "get",
          this.salesOrderId,
          item.line_number,
          this.userId
        );
        if (shippedData?.Data) {
          this.shippedDataList = shippedData.Data;
          this.showLinkDialog = true;
          this.selectedLink = value;
          this.shippedDataList?.forEach((element) => {
            element.Shipped = Utility.displayDateFormat(element.Shipped);
          });
        }
      }
    },
    closeLinkDialog() {
      this.showLinkDialog = false;
      this.selectedLink = "";
      this.pickedDataList = [];
      this.receivedDataList = [];
      this.shippedDataList = [];
    },
    // get Inbound grid Data
    async getInboundGridData() {
      let inboundData = this.salesOrderJson?.inbound
        ? JSON.parse(this.salesOrderJson?.inbound).Inbound
        : "";
      inboundData?.forEach((element) => {
        element.created_date = Utility.displayDateFormat(element.created_date);
      });
      this.inboundDataList = inboundData;
    },
    // Get outbound Grid Data
    async getOutboundGridData() {
      let outboundData = this.salesOrderJson?.outbound
        ? JSON.parse(this.salesOrderJson?.outbound).Outbound
        : "";
      outboundData?.forEach((element) => {
        element.created_date = Utility.displayDateFormat(element?.created_date);
        element.retrieved = element?.retrieved
          ? Utility.displayDateFormat(element?.retrieved)
          : "";
      });
      this.outboundDataList = outboundData;
    },
    async getMessageData(msgId) {
      this.onClickDetailsView("outboundLog", msgId);
    },
    onClickDetailsView(text, item) {
      this.showDialogDetailsBox = true;
      if (text == "InboundJSON") {
        this.dialogBoxHeader = "View Inbound Request JSON";
        this.displayData = item.request_json;
      } else if (text == "InboundXML") {
        this.dialogBoxHeader = "View Inbound Request XML";
        this.displayData = item.request_xml.replaceAll(">", ">\n");
      } else if (text == "OutboundXML") {
        this.dialogBoxHeader = "View Outbound Request XML";
        this.displayData = item.replaceAll(">", ">\n");
      } else if (text == "OutboundJSON") {
        this.dialogBoxHeader = "View Outbound Request JSON";
        this.displayData = item;
      } else if (text == "outboundLog") {
        this.outboundData.push(item);
        this.dialogBoxHeader = "View Outbound Response";
        this.showOutboundLog = true;
      }
    },
    outboundOrderLine() {
      this.salesOrderJson.order_list?.forEach((element) => {
        this.lineTypeList?.forEach((ele) => {
          if (ele.so_type_id == element.order_line_type) {
            element["outboundPresent"] = ele.to_ship;
          }
        });
      });
    },
    convertTime() {
      
      let timeZoneTime = Utility.getTimeFromLocalToTimeZone();
      this.salesOrderJson = JSON.parse(
        JSON.stringify(this.salesOrderDetails.Result[0])
      );
      this.mapSalesOrderResultFields();
       this.salesOrderJson?.comments?JSON.parse(this.salesOrderJson?.comments)?.CommentsInfo?.length > 0
      ? this.getCommentsData()
      : "":"";
    this.salesOrderJson?.inbound?JSON.parse(this.salesOrderJson?.inbound)?.Inbound?.length > 0
      ? this.getInboundGridData()
      : "":"";
    this.salesOrderJson?.outbound?JSON.parse(this.salesOrderJson?.outbound)?.Outbound.length > 0
      ? this.getOutboundGridData()
      : "":"";
      this.orderDate = this.salesOrderJson.ordered_date;
      this.newHireDate = this.salesOrderJson.new_hire_date;
      this.shipByDate = this.salesOrderJson.requested_ship_date;
      this.salesOrderJson.cdate = this.salesOrderJson?.cdate
        ? Utility.displayDateFormat(this.salesOrderJson.cdate)
        : Utility.displayDateFormat(new Date());
      this.salesOrderJson.udate = this.salesOrderJson?.udate
        ? Utility.displayDateFormat(this.salesOrderJson.udate)
        : Utility.displayDateFormat(new Date());
      this.hold = this.salesOrderJson.is_hold;
      this.salesOrderJson.ordered_date = this.salesOrderJson?.ordered_date
        ? Utility.inputDateFormat(
            this.computedDateFormattedMomentjs,
            timeZoneTime,
            false
          )
        : Utility.inputDateFormat(new Date(), timeZoneTime, false);
      if (
        this.salesOrderJson.new_hire_date == "1900-01-01T00:00:00" ||
        !this.salesOrderJson.new_hire_date
      )
        this.salesOrderJson.new_hire_date = "";
      else {
        this.salesOrderJson.new_hire_date = Utility.inputDateFormat(
          this.newHireComputedDateFormattedMomentjs,
          timeZoneTime,
          false
        );
      }
      if (
        this.salesOrderJson.requested_ship_date == "1900-01-01T00:00:00" ||
        !this.salesOrderJson?.requested_ship_date
      ) {
        this.salesOrderJson.requested_ship_date = "";
      } else {
        this.salesOrderJson.requested_ship_date = Utility.inputDateFormat(
          this.shipcomputeDateFormattedMomentjs,
          timeZoneTime,
          false
        );
      }
      if (
        this.salesOrderJson?.last_receipt_date == "1900-01-01T00:00:00" ||
        !this.salesOrderJson?.last_receipt_date
      ) {
        this.salesOrderJson.last_receipt_date = "";
      } else {
        this.salesOrderJson.last_receipt_date = Utility.displayDateFormat(
          this.salesOrderJson?.last_receipt_date,
          "MM/DD/YYYY"
        );
      }
        if (
          this.salesOrderJson?.last_shipped_date == "1900-01-01T00:00:00" ||
          !this.salesOrderJson?.last_shipped_date
        ) {
          this.salesOrderJson.last_shipped_date = "";
        } else {
          this.salesOrderJson.last_shipped_date = this.salesOrderJson
            ?.last_shipped_date
            ? Utility.displayDateFormat(
                this.salesOrderJson?.last_shipped_date,
                "MM/DD/YYYY"
              )
            : "";
        
      }
    },
    deleteComment(com_sequence_number) {
      this.tempCommentList = this.tempCommentList.filter(
        (item) => item.com_sequence_number !== com_sequence_number
      );

      // Set is_Delete to true in commentList
      let commentIndex = this.commentList.findIndex(
        (item) => item.com_sequence_number === com_sequence_number
      );
      if (commentIndex !== -1) {
        this.commentList[commentIndex].is_Deleted = true;
        this.commentList[commentIndex].is_Added = false;
        this.commentList[commentIndex].is_Edited = false;
      }
    },
    editComment(com_sequence_number) {
      this.showAddComments = true;
      this.commentDialogHeader = "Edit Comments";
      let commentObj = this.commentList.find(
        (item) => item.com_sequence_number == com_sequence_number
      );
      this.editableComment = commentObj.comments;
      this.commentId = com_sequence_number;
    },

    clearComments() {
      this.showAddComments = false;
      this.editableComment = "";
      this.commentId = 0;
    },

    addComments() {
      this.showAddComments = true;
      this.commentDialogHeader = "Add Comments";
      this.commentId = 0;
    },
    submitComments(comments, commentId) {
      this.showAddComments = false;
      let userName = `${this.fname} ${this.lname}`;
      let currentDate = new Date().toLocaleDateString();
      if (commentId === 0) {
        // Add a new comment
        const newComment = {
          com_sequence_number: this.commentList.length + 1,
          comments: comments,
          name: userName,
          date: currentDate,
          socomments_id: 0,
          showDelete: true,
          showEdit: true,
          is_Edited: false, // Set is_Edit to false
          is_Deleted: false, // Set is_Delete to false
          is_Added: true, // Set is_Added to true
        };
        this.commentList.push(newComment);
        this.tempCommentList.unshift(newComment); // Update tempCommentList
      } else {
        // Update an existing comment
        let commentIndex = this.commentList.findIndex(
          (item) => item.com_sequence_number === commentId
        );
        if (commentIndex !== -1) {
          this.commentList[commentIndex] = {
            ...this.commentList[commentIndex],
            comments: comments,
            name: userName,
            date: currentDate,
            is_Deleted: false, // Set is_Delete to false
            is_Added: false,
            is_Edited: true, // Set is_Edit to true for updates
            is_Delete: false, // Keep is_Delete false // Set is_Added to false for updates
          };

          // Update the corresponding comment in tempCommentList
          let tempCommentIndex = this.tempCommentList.findIndex(
            (item) => item.com_sequence_number === commentId
          );
          if (tempCommentIndex !== -1) {
            this.tempCommentList[tempCommentIndex] = {
              ...this.tempCommentList[tempCommentIndex],
              comments: comments,
              name: userName,
              date: currentDate,
              is_Edit: true,
              is_Delete: false,
              is_Added: false,
            };
          }
        }
      }
      this.showCommentList = false;
      this.$nextTick(() => {
        this.showCommentList = true;
      });

      this.clearComments();
    },
    //Retry Outbound Message
    retryOutboundMsg() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("/so/so_outbound_process_retry?user_id=" + this.userId + "&sono=" + this.salesOrderJson.order_number)
        .then((response) => {
          if (response.status == 200) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    soRevertToBackorderClicked() {
      if (this.isShippingHold) return;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        UserId: parseInt(this.userId),
        so_id: parseInt(this.salesOrderJson.so_id),
      };
      this.axios
        .post("/so/so_revert_to_backorder", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);           
            this.revertToBackOrderDialog = false;
            this.$router.push({
              name: "salesOrderDetails",
              params: {
                id: btoa(this.salesOrderId),
              },
            });
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
          this.revertToBackOrderDialog = false;
          this.forceAllocateOrderDialog = false;
          this.clearShippingAuditDialog = false;
        });
    },
    forceAllocateOrderClicked() {
      if (this.isShippingHold) return;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        UserId: parseInt(this.userId),
        so_id: parseInt(this.salesOrderJson.so_id),
      };
      this.axios
        .post("/so/so_force_allocate_order", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.forceAllocateOrderDialog = false;
            this.$router.push({
              name: "salesOrderDetails",
              params: {
                id: btoa(this.salesOrderId),
              },
            });
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
          this.revertToBackOrderDialog = false;
          this.forceAllocateOrderDialog = false;
          this.clearShippingAuditDialog = false;
        });
    },
    clearShippingAuditClicked() {
      if (this.isShippingHold) return;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        UserId: parseInt(this.userId),
        so_id: parseInt(this.salesOrderJson.so_id),
      };
      this.axios
        .post("/so/so_clear_shipping_audit", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.clearShippingAuditDialog = false;
            this.$router.push({
              name: "salesOrderDetails",
              params: {
                id: btoa(this.salesOrderId),
              },
            });
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
          this.revertToBackOrderDialog = false;
          this.forceAllocateOrderDialog = false;
          this.clearShippingAuditDialog = false;
        });
    },
    soCallLogsDialogCancel() {
      this.followDate = new Date(new Date().getTime()).toISOString().split("T")[0];
      this.conDate = new Date(new Date().getTime()).toISOString().split("T")[0];
      this.conTime = moment().format("HH:mm");
      this.contactDate = false;
      this.contactTime = false;
      this.followupDate = false;
      this.recipientName = "";
      this.method = "";
      this.outcome = "";
      this.notes = "";
      this.nextAction = "";
      this.soCallLogsDialog = false;
      this.$refs.soCallLogForm.resetValidation();
    },
    async getSOCallLogs() {
      let obj = {
        Pass: 4,
        somast_callslog_id: 0,
        so_key: this.salesOrderJson.so_id,
        ContactDateTime: "2026-05-26T07:33:59.210Z",
        RecipientName: "",
        Method: "",
        Outcome: "",
        Notes: "",
        NextAction: "",
        FollowupDate: "2026-05-26T07:33:59.210Z",
        Createdby: 0,
        Modifiedby: 0,
      };
      let data = await salesService.salesOrderCallLogs("post", obj, false);
      const newArr = data.map((obj) => {
        return {
          ...obj,
          ContactDateTime: obj.ContactDateTime !== undefined ? Utility.displayDateFormat(obj.ContactDateTime) : "",
          FollowupDate: obj.FollowupDate !== undefined ? Utility.displayDateFormat(obj.FollowupDate) : "",
          is_Added: false,
          is_Edited: false,
          is_Deleted: false,
        };
      });
      this.callLogsData = newArr;
    },
    soCallLogsUpdateSubmit() {
      if (!this.$refs.soCallLogForm.validate()) return;
      const isNew = this.callLogSubmitBtnName === "Submit";
      const payload = {
        Pass: isNew ? 1 : 2,
        somast_callslog_id: isNew ? 0 : this.selectedCallLogId,
        so_key: this.salesOrderJson.so_id,
        ContactDateTime: moment(`${this.conDate} ${this.conTime}`, "YYYY-MM-DD HH:mm").format("MM/DD/YYYY hh:mm:ss A"),
        RecipientName: this.recipientName,
        Method: this.method,
        Outcome: this.outcome,
        Notes: this.notes,
        NextAction: this.nextAction,
        FollowupDate: this.followDate
          ? moment(this.followDate, "YYYY-MM-DD").format("MM/DD/YYYY hh:mm:ss A")
          : moment().format("MM/DD/YYYY hh:mm:ss A"),
        Createdby: parseInt(this.userId),
        Modifiedby: parseInt(this.userId),
      };
      let LoaderDialog = { visible: true, title: "Please Wait..." };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .post("/so/so_call_log_upsert", payload)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            if (isNew) {
              this.getSOCallLogs();
            } else {
              const index = this.callLogsData.findIndex((x) => x.somast_callslog_id === this.selectedCallLogId);
              if (index !== -1) {
                this.callLogsData[index] = {
                  ...this.callLogsData[index],
                  ContactDateTime: payload.ContactDateTime,
                  FollowupDate: payload.FollowupDate,
                  RecipientName: payload.RecipientName,
                  Method: payload.Method,
                  Outcome: payload.Outcome,
                  Notes: payload.Notes,
                  NextAction: payload.NextAction,
                };
                this.callLogsData = [...this.callLogsData];
              }
            }
            let Alert = { type: "success", isShow: true, message: response.data.body.message };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.soCallLogsDialogCancel();
            this.selectedCallLogId = 0;
          } else {
            let Alert = { type: "error", isShow: true, message: response.data.message };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = { type: "error", isShow: true, message: Utility.apiError(error) };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    deleteCallLog() {
      const nowFormatted = moment().format("MM/DD/YYYY hh:mm:ss A");
      let LoaderDialog = { visible: true, title: "Please Wait..." };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .post("/so/so_call_log_upsert", {
          Pass: 3,
          somast_callslog_id: this.selectedCallLogId,
          so_key: this.salesOrderJson.so_id,
          ContactDateTime: nowFormatted,
          RecipientName: "",
          Method: "",
          Outcome: "",
          Notes: "",
          NextAction: "",
          FollowupDate: nowFormatted,
          Createdby: parseInt(this.userId),
          Modifiedby: parseInt(this.userId),
        })
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            const index = this.callLogsData.findIndex((x) => x.somast_callslog_id === this.selectedCallLogId);
            if (index !== -1) this.callLogsData.splice(index, 1);
            this.callLogsData = [...this.callLogsData];
            let Alert = { type: "success", isShow: true, message: response.data.body.message };
            this.$store.commit("ConfigModule/Alert", Alert);
          } else {
            let Alert = { type: "error", isShow: true, message: response.data.message };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          this.callLogDeleteDialog = false;
          this.selectedCallLogId = 0;
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = { type: "error", isShow: true, message: Utility.apiError(error) };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    deleteCallLogDetails(item) {
      this.selectedCallLogId = item.somast_callslog_id;
      this.callLogDeleteDialog = true;
    },
    editCallLogDetails(item) {
      this.conDate = item.ContactDateTime !== "" ? moment(item.ContactDateTime, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DD") : "";
      this.conTime = item.ContactDateTime !== "" ? moment(item.ContactDateTime, "MM/DD/YYYY hh:mm:ss A").format("HH:mm") : "";
      this.recipientName = item.RecipientName;
      this.method = item.Method;
      this.outcome = item.Outcome;
      this.notes = item.Notes;
      this.nextAction = item.NextAction;
      this.followDate = item.FollowupDate !== "" ? moment(item.FollowupDate, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DD") : "";
      this.callLogSubmitBtnName = "Update";
      this.selectedCallLogId = item.somast_callslog_id;
      this.soCallLogsDialog = true;
    },
    newSOCallLogClicked() {
      this.soCallLogsDialog = true;
      this.callLogSubmitBtnName = "Submit";
    },
    async labelDetails(label, dialogName, label_type) {
      let LoaderDialog = {
        visible: true,
        title: 'Please Wait...',
      };
      this.$store.commit('ConfigModule/LoaderDialog', LoaderDialog);
      this.labelDialogName = dialogName + " Details";
      this.labelType = label_type;
      if (label_type === "PDF") {
        this.labelRaw = label;
        this.labelLink = `data:application/pdf;base64,${label}#toolbar=0`;
      } else if (label_type === "IMG") {
        this.labelLink = `data:image/png;base64,${label}`;
      } else if (label_type === "GIF") {
        this.labelLink = `data:image/gif;base64,${label}`;
      } else {
        this.labelZpl = atob(label).replace(/\^POI/gi, "^PON");
        try {
          const response = await fetch(
            "https://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/",
            {
              method: "POST",
              headers: {
                "Accept": "application/pdf",
                "Content-Type": "application/x-www-form-urlencoded"
              },
              body: this.labelZpl
            }
          );
          if (!response.ok) throw new Error(await response.text());
          const blob = await response.blob();
          this.labelLink = URL.createObjectURL(blob) + "#toolbar=0";
        } catch (error) {
          // Preview can't be rendered (eg. Labelary's 50-label cap) - printing still works via the direct-to-printer path below
          this.labelLink = "";
        }
      }
      this.labelDialog = true;
      LoaderDialog.visible = false;
      this.$store.commit('ConfigModule/LoaderDialog', LoaderDialog);
    },
    printLabel() {
      if (this.labelType === "IMG" || this.labelType === "GIF") {
        window.print();
      } else if (this.labelType === "PDF") {
        Utility.printZPLPDF(this.labelRaw, EncryptUtility.localStorageDecrypt("secondaryName"));
      } else {
        PrinterDetails.printLabelData(this.labelZpl, EncryptUtility.localStorageDecrypt("secondaryName"));
      }
    },
    async viewLabelHistory(item, dir) {
      let historyData = await salesOrderEditService.getSoLabelDetails("get", 1, item.recvr_id, this.userId, dir, 0);
      if (historyData?.Data) {
        this.labelHistoryData = historyData.Data;
        this.labelHistoryData.forEach((element) => {
          element.cdate = Utility.displayDateFormat(element.cdate);
        });
        this.labelHistoryDir = dir;
        this.labelHistorySorecpId = item.recvr_id;
        this.labelHistoryDialog = true;
      }
    },
    async viewLabelContent(historyItem) {
      let contentData = await salesOrderEditService.getSoLabelDetails(
        "get",
        2,
        this.labelHistorySorecpId,
        this.userId,
        this.labelHistoryDir,
        historyItem.solabel_id,
      );
      if (contentData?.Data?.[0]?.label) {
        const { label, label_type } = contentData.Data[0];
        await this.labelDetails(label, this.labelHistoryDir === "O" ? "Outbound" : "Inbound", label_type);
      }
    },
    closeLabelHistoryDialog() {
      this.labelHistoryDialog = false;
      this.labelHistoryDir = "";
      this.labelHistorySorecpId = 0;
      this.labelHistoryData = [];
    },
  },
  components: {
    breadcrumbComp,
    addressComp,
    BackToTop,
    DisplayCommentsComp,
    AddCommentsComp,
  },
};
